(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bannerpanda"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panda-family-close')) {
  customElements.define('panda-family-close', class extends HTMLElement {
    connectedCallback() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.querySelector('.pf-close__copy').animate([{opacity:0,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'});
        this.observer.disconnect();
      }, {threshold:0.15});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bannervideo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('panda-adults-hero')) {
    customElements.define('panda-adults-hero', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const signal = this.lifecycle.signal;
        this.setupRotator(signal);
        this.videos = Array.from(this.querySelectorAll('video'));
        this.button = this.querySelector('[data-pa-playback]');
        if (!this.videos.length || !this.button) return;
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.reduced.matches;
        this.inView = false;
        this.sync = () => {
          const view = this.mobile.matches && this.classList.contains('pa-hero--mobile-media') ? 'mobile' : 'desktop';
          const active = this.videos.find(video => video.closest('[data-pa-view]').dataset.paView === view);
          this.activeVideo = active;
          this.button.hidden = !active;
          this.videos.forEach(video => {
            if (video !== active || this.userPaused || !this.inView || document.hidden) video.pause();
            else {
              video.muted = true;
              const attempt = video.play();
              if (attempt) attempt.catch(() => { if (video === this.activeVideo) this.updateControl(); });
            }
          });
          this.updateControl();
        };
        this.updateControl = () => {
          const paused = !this.activeVideo || this.activeVideo.paused;
          this.button.setAttribute('aria-label', paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause);
          this.button.querySelector('[data-pa-play-icon]').hidden = !paused;
          this.button.querySelector('[data-pa-pause-icon]').hidden = paused;
        };
        this.button.addEventListener('click', () => {
          this.userPaused = this.activeVideo ? !this.activeVideo.paused : false;
          this.sync();
        }, { signal });
        this.videos.forEach(video => {
          video.addEventListener('play', this.updateControl, { signal });
          video.addEventListener('pause', this.updateControl, { signal });
        });
        this.mobile.addEventListener('change', this.sync, { signal });
        this.reduced.addEventListener('change', () => { this.userPaused = this.reduced.matches; this.sync(); }, { signal });
        document.addEventListener('visibilitychange', this.sync, { signal });
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold:0.05 });
        this.observer.observe(this);
        this.sync();
      }

      setupRotator(signal) {
        clearInterval(this.rotTimer);
        this.rotObserver?.disconnect();
        const rot = this.querySelector('[data-pa-rotator]');
        if (!rot) return;
        const words = Array.from(rot.querySelectorAll('.pa-rotator__word'));
        if (words.length < 2) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const ms = Math.max(1500, Number(rot.dataset.interval) || 2600);
        rot.style.setProperty('--pa-rot-ms', ms + 'ms');
        let index = 0;
        let inView = true;
        const fit = () => { rot.style.width = words[index].getBoundingClientRect().width + 'px'; };
        const restartProgress = () => {
          rot.classList.remove('is-ticking');
          void rot.offsetWidth;
          rot.classList.add('is-ticking');
        };
        const tick = () => {
          const prev = words[index];
          index = (index + 1) % words.length;
          const next = words[index];
          prev.classList.remove('is-active');
          prev.classList.add('is-leaving');
          setTimeout(() => prev.classList.remove('is-leaving'), 750);
          next.classList.add('is-active');
          fit();
          restartProgress();
        };
        const stop = () => {
          clearInterval(this.rotTimer);
          this.rotTimer = null;
          rot.classList.remove('is-ticking');
        };
        const start = () => {
          stop();
          if (reduced.matches || document.hidden || !inView) return;
          restartProgress();
          this.rotTimer = setInterval(tick, ms);
        };
        fit();
        requestAnimationFrame(() => rot.classList.add('is-ready'));
        document.fonts?.ready.then(fit).catch(() => {});
        window.addEventListener('resize', fit, { signal, passive: true });
        document.addEventListener('visibilitychange', start, { signal });
        reduced.addEventListener('change', start, { signal });
        if ('IntersectionObserver' in window) {
          this.rotObserver = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; start(); });
          this.rotObserver.observe(rot);
        } else {
          start();
        }
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        this.observer?.disconnect();
        this.rotObserver?.disconnect();
        clearInterval(this.rotTimer);
        this.videos?.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barrapanda"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('panda-announcement-bar')) {
    customElements.define('panda-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const button = this.querySelector('.panda-notices__pause');
        if (!button) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
        }, { signal: this.events.signal });
      }

      disconnectedCallback() {
        this.events?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comunidad"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('panda-community-v2')) {
  customElements.define('panda-community-v2', class extends HTMLElement {
    connectedCallback() {
      this.stopMotion();
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(options), {...options, once:true});
      } else this.initialize(options);
    }
    initialize(options) {
      if (!this.isConnected) return;
      this.animations = new Set();
      this.setupCommunity(options);
      this.panels = [...this.querySelectorAll('[data-offer-panel]')];
      this.tabs = [...this.querySelectorAll('[data-offer-tab]')];
      this.classList.add('is-ready');
      const picker = this.querySelector('[data-offer-picker]');
      if (picker) picker.hidden = false;
      this.tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => this.setOffer(tab.dataset.offerTab), options);
        tab.addEventListener('keydown', event => {
          if (this.pending) return;
          const next = {ArrowRight:(index+1)%this.tabs.length,ArrowLeft:(index-1+this.tabs.length)%this.tabs.length,Home:0,End:this.tabs.length-1}[event.key];
          if (next === undefined) return;
          event.preventDefault();
          this.setOffer(this.tabs[next].dataset.offerTab);
          this.tabs[next].focus();
        }, options);
      });
      this.panels.forEach(panel => {
        if (this.tabs.length) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.offerTab === panel.dataset.offerPanel).id);
        }
        panel.querySelector('[data-variant-select]')?.addEventListener('change', () => this.updateVariant(), options);
        panel.querySelector('[data-quantity]')?.addEventListener('input', () => this.updateQuantityButtons(), options);
        panel.querySelectorAll('[data-quantity-change]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => this.changeQuantity(Number(button.dataset.quantityChange)), options);
        });
        panel.querySelector('.pc__form')?.addEventListener('submit', event => this.addToCart(event), options);
      });
      this.setOffer(this.activeOffer || this.panels[0]?.dataset.offerPanel);
      this.setupMotion(options);
    }
    setOffer(key) {
      if (this.pending) return;
      const panel = this.panels.find(item => item.dataset.offerPanel === key);
      if (!panel) return;
      const changed = this.activeOffer && this.activeOffer !== key;
      this.activeOffer = key;
      this.panel = panel;
      this.panels.forEach(item => item.hidden = item !== panel);
      this.tabs.forEach(tab => {
        const active = tab.dataset.offerTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.form = panel.querySelector('.pc__form');
      this.select = panel.querySelector('[data-variant-select]');
      this.quantity = panel.querySelector('[data-quantity]');
      this.button = panel.querySelector('[data-add-button]');
      this.querySelector('[data-product-title]').textContent = panel.dataset.offerTitle;
      this.updateProductImage(panel.dataset.offerImage, panel.dataset.offerAlt);
      this.updateVariant();
      if (changed) this.animateIn(panel, 0, 300);
    }

    updateVariant() {
      const option = this.select?.selectedOptions[0];
      if (!option) return;
      const data = option.dataset;
      const tilePrice = this.tabs.find(tab => tab.dataset.offerTab === this.activeOffer)?.querySelector('[data-offer-price]');
      if (tilePrice) tilePrice.textContent = data.price;
      this.panel.querySelector('[data-product-price]').textContent = data.price;
      const compare = this.panel.querySelector('[data-product-compare]');
      compare.textContent = data.compare || '';
      compare.hidden = !data.compare;
      if (this.button) {
        this.button.disabled = this.pending || data.available !== 'true';
        this.button.querySelector('[data-button-label]').textContent = data.available === 'true' ? this.button.dataset.label : this.dataset.soldOut;
      }
      if (this.quantity) {
        this.quantity.min = data.min || '1';
        this.quantity.step = data.step || '1';
        if (data.max) this.quantity.max = data.max;
        else this.quantity.removeAttribute('max');
        this.quantity.value = String(this.normalizedQuantity(Number(this.quantity.value)));
      }
      if (this.panel.dataset.customImage !== 'true') this.updateProductImage(data.image, data.alt);
      const feedback = this.panel.querySelector('[data-cart-feedback]');
      if (feedback) feedback.hidden = true;
      this.updateQuantityButtons();
    }
    updateProductImage(src, alt) {
      let image = this.querySelector('.pc__product-image');
      if (!src) {if (image) image.hidden = true; return;}
      if (!image) {
        image = document.createElement('img');
        image.className = 'pc__product-image';
        image.width = 76; image.height = 88;
        this.querySelector('.pc__product-summary')?.prepend(image);
      }
      image.hidden = false;
      image.removeAttribute('srcset');
      if (image.getAttribute('src') !== src) image.src = src;
      image.alt = alt || '';
    }
    normalizedQuantity(value) {
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      let valid = min + Math.max(0, Math.round(((Number.isFinite(value) ? value : min) - min) / step)) * step;
      if (valid > max) valid = min + Math.max(0, Math.floor((max - min) / step)) * step;
      return valid;
    }
    changeQuantity(direction) {
      if (!this.quantity || this.pending) return;
      const current = this.normalizedQuantity(Number(this.quantity.value));
      this.quantity.value = String(this.normalizedQuantity(current + direction * (Number(this.quantity.step) || 1)));
      this.quantity.dispatchEvent(new Event('change', {bubbles: true}));
      this.updateQuantityButtons();
    }
    updateQuantityButtons() {
      if (!this.quantity) return;
      const value = Number(this.quantity.value);
      const min = Number(this.quantity.min) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      const step = Number(this.quantity.step) || 1;
      this.panel.querySelectorAll('[data-quantity-change]').forEach(button => {
        button.disabled = Boolean(this.pending) || (Number(button.dataset.quantityChange) < 0 ? value <= min : value + step > max);
      });
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.pending || !this.button || this.button.disabled || !this.form.reportValidity()) return;
      const body = new FormData(this.form);
      const cart = document.querySelector('cart-drawer, cart-notification');
      let sectionIds = [];
      if (typeof cart?.getSectionsToRender === 'function') {
        sectionIds = cart.getSectionsToRender().map(section => section.id);
      } else {
        sectionIds = [...document.querySelectorAll('cart-icon, cart-drawer-component, #cart-icon-bubble')].map(node => node.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '')).filter(Boolean);
      }
      sectionIds = [...new Set(sectionIds)].slice(0, 5);
      if (sectionIds.length) {
        body.set('sections', sectionIds.join(','));
        body.set('sections_url', window.location.pathname);
      }
      const feedback = this.panel.querySelector('[data-cart-feedback]');
      const message = this.panel.querySelector('[data-cart-message]');
      feedback.hidden = true;
      feedback.classList.remove('has-error');
      this.pending = true;
      this.tabs.forEach(tab => tab.disabled = true);
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.querySelector('[data-button-label]').textContent = this.dataset.adding;
      this.select.disabled = true;
      this.quantity.disabled = true;
      this.updateQuantityButtons();
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const url = this.dataset.cartAddUrl.replace(/\.js$/, '') + '.js';
        const response = await fetch(url, {method: 'POST', body, headers: {Accept: 'application/json'}, credentials: 'same-origin', signal: controller.signal});
        const result = await response.json();
        if (!response.ok || result.status) {
          const error = new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          error.confirmed = true;
          throw error;
        }
        message.textContent = this.dataset.added;
        feedback.hidden = false;
        try {
          this.refreshCartSections(result.sections);
        } catch (_) {}
      } catch (error) {
        message.textContent = error.confirmed ? error.message : this.dataset.networkError;
        feedback.classList.add('has-error');
        feedback.hidden = false;
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.tabs.forEach(tab => tab.disabled = false);
        this.select.disabled = false;
        this.quantity.disabled = false;
        const available = this.select.selectedOptions[0]?.dataset.available === 'true';
        this.button.disabled = !available;
        this.button.removeAttribute('aria-busy');
        this.button.querySelector('[data-button-label]').textContent = available ? this.button.dataset.label : this.dataset.soldOut;
        this.updateQuantityButtons();
      }
    }
    refreshCartSections(sections) {
      if (!sections) return;
      for (const html of Object.values(sections)) {
        if (typeof html !== 'string') continue;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        for (const selector of ['cart-icon', 'cart-drawer-component', 'cart-drawer', 'cart-notification', '#cart-icon-bubble']) {
          const current = document.querySelector(selector);
          const replacement = parsed.querySelector(selector);
          if (current && replacement) current.replaceWith(replacement);
        }
      }
    }

    setupCommunity(options) {
      this.track = this.querySelector('[data-review-track]');
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.dots = [...this.querySelectorAll('[data-review-dot]')];
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.resizeObserver?.disconnect();
      this.querySelector('[data-review-controls]')?.removeAttribute('hidden');
      this.track?.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {this.frame = 0; this.updateCarousel();});
      }, {...options, passive: true});
      this.querySelector('[data-review-prev]')?.addEventListener('click', () => this.goToReview(this.reviewIndex - 1), options);
      this.querySelector('[data-review-next]')?.addEventListener('click', () => this.goToReview(this.reviewIndex + 1), options);
      this.dots.forEach(dot => dot.addEventListener('click', () => this.goToReview(Number(dot.dataset.reviewDot)), options));
      this.track?.addEventListener('keydown', event => {
        if (event.target !== this.track || !this.trackOverflow) return;
        const target = {ArrowRight:this.reviewIndex+1,ArrowLeft:this.reviewIndex-1,Home:0,End:this.lastStop}[event.key];
        if (target === undefined) return;
        event.preventDefault();
        this.goToReview(target);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-review-card]');
        if (card) this.goToReview(Number(card.dataset.reviewIndex));
      }, options);
      this.mobile.addEventListener('change', () => this.resizeCarousel(), options);
      if ('ResizeObserver' in window && this.track) {
        this.resizeObserver = new ResizeObserver(() => this.resizeCarousel());
        this.resizeObserver.observe(this.track);
      }
      window.addEventListener('resize', () => this.resizeCarousel(), options);
      this.resizeCarousel();
      const host = this.querySelector('[data-buy-host]');
      if (!host || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      this.dialog = this.querySelector('[data-buy-dialog]');
      if (!this.dialog) {
        this.dialog = document.createElement('dialog');
        this.dialog.className = 'pc__dialog';
        this.dialog.dataset.buyDialog = '';
        this.dialog.id = 'PandaCommunityDialog-' + this.dataset.sectionId;
        const heading = host.querySelector('[data-product-title]');
        heading.id = 'PandaCommunityDialogTitle-' + this.dataset.sectionId;
        this.dialog.setAttribute('aria-labelledby', heading.id);
        this.append(this.dialog);
        this.dialog.append(host);
      }
      host.querySelector('[data-close-dialog]').hidden = false;
      host.querySelector('[data-close-dialog]').addEventListener('click', () => this.closeDialog(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog();
      }, options);
      this.dialog.addEventListener('cancel', event => {event.preventDefault(); this.closeDialog();}, options);
      this.dialog.addEventListener('close', () => {if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});}, options);
      this.querySelectorAll('[data-quick-buy]').forEach(trigger => {
        trigger.setAttribute('aria-haspopup','dialog');
        trigger.setAttribute('aria-controls',this.dialog.id);
        trigger.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.trigger = trigger;
          if (!this.pending) this.setOffer(this.panels.some(panel => panel.dataset.offerPanel === trigger.dataset.pack) ? trigger.dataset.pack : this.panels[0]?.dataset.offerPanel);
          if (!this.dialog.open) {this.dialog.showModal(); this.dialog.scrollTop = 0;}
        }, options);
      });
    }
    resizeCarousel() {
      if (!this.track || !this.cards.length) return;
      const keep = this.reviewIndex || 0;
      this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const origin = this.cards[0].offsetLeft;
      this.stops = [];
      this.cards.forEach(card => {
        const offset = Math.min(this.maximum, Math.max(0, card.offsetLeft - origin));
        if (!this.stops.length || Math.abs(offset - this.stops[this.stops.length-1]) > 2) this.stops.push(offset);
      });
      this.lastStop = this.stops.length - 1;
      this.trackOverflow = this.maximum > 2;
      this.track.tabIndex = this.trackOverflow ? 0 : -1;
      const controls = this.querySelector('[data-review-controls]');
      if (controls) controls.hidden = !this.trackOverflow;
      this.dots.forEach((dot,index) => {dot.hidden = index > this.lastStop;});
      this.goToReview(Math.min(keep,this.lastStop), true);
      this.updateCarousel();
    }
    updateCarousel() {
      if (!this.track || !this.stops?.length) return;
      const left = this.track.scrollLeft;
      this.reviewIndex = this.stops.reduce((nearest,offset,index) => Math.abs(offset-left) < Math.abs(this.stops[nearest]-left) ? index : nearest, 0);
      this.dots.forEach((dot,index) => {if(index===this.reviewIndex) dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      if(previous) previous.disabled = left <= 2;
      if(next) next.disabled = left >= this.maximum-2;
      const bounds = this.track.getBoundingClientRect();
      const visible = this.cards.map((card,index) => ({index,box:card.getBoundingClientRect()})).filter(({box}) => box.left+box.width/2 >= bounds.left && box.left+box.width/2 <= bounds.right);
      const first = (visible[0]?.index ?? this.reviewIndex) + 1;
      const last = (visible.at(-1)?.index ?? this.reviewIndex) + 1;
      const status = this.querySelector('[data-review-position]');
      const position = (first === last ? String(first).padStart(2,'0') : `${first}–${last}`) + ' / ' + String(this.cards.length).padStart(2,'0');
      if(status && status.textContent !== position) {
        status.textContent = position;
        status.setAttribute('aria-label', this.dataset.positionLabel.replace('[first]',first).replace('[last]',last).replace('[total]',this.cards.length));
      }
    }
    goToReview(index, instant = false) {
      if (!this.track || !this.stops?.length) return;
      const target = Math.max(0,Math.min(this.lastStop,index));
      this.track.scrollTo({left:this.stops[target],behavior:instant || !this.motionEnabled ? 'instant':'smooth'});
    }
    get motionEnabled() {return this.dataset.motion !== 'false' && !this.reduced?.matches;}
    animateIn(node, delay = 0, duration = 600) {
      if (!node?.animate || !this.motionEnabled) return;
      const animation = node.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration,delay,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});
      this.animations.add(animation);
      animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
    }
    setupMotion(options) {
      this.reduced.addEventListener('change', () => this.stopMotion(), options);
      if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
      this.motionObserver = new IntersectionObserver(entries => {
        let order = 0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.motionObserver.unobserve(entry.target);
          this.animateIn(entry.target, Math.min(order++ * 60,180));
        });
      },{threshold:.08});
      [this.querySelector('.pc__heading'),...this.cards].filter(Boolean).forEach(node => this.motionObserver.observe(node));
    }
    stopMotion() {
      this.motionObserver?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
    }
    closeDialog() {
      if (!this.dialog?.open || this.closing) return;
      if (!this.motionEnabled || !this.dialog.animate) {this.dialog.close();return;}
      this.closing = true;
      const animation = this.dialog.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(16px)'}],{duration:150,easing:'ease-out'});
      this.animations.add(animation);
      animation.finished.catch(() => {}).finally(() => {
        this.animations.delete(animation);
        this.closing = false;
        if (this.dialog?.open) this.dialog.close();
      });
    }
    disconnectedCallback() {
      this.stopMotion();
      this.events?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame=0;
      if (this.dialog?.open) this.dialog.close();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foterr"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pa-footer')) {
  customElements.define('pa-footer', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const mobile = window.matchMedia('(max-width: 749px)');
      const accs = [...this.querySelectorAll('[data-foot-acc]')];
      const syncAcc = () => accs.forEach(d => { d.open = !mobile.matches; });
      accs.forEach(d => d.querySelector('summary').addEventListener('click', e => { if (!mobile.matches) e.preventDefault(); }, {signal}));
      syncAcc();
      mobile.addEventListener('change', syncAcc, {signal});

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.animate !== 'true' || reduced || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }
      this.classList.add('is-ready');
      this.io = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) { this.classList.add('is-visible'); this.io.disconnect(); }
      }, {threshold: 0.12});
      this.io.observe(this);
    }
    disconnectedCallback() { this.abort?.abort(); this.io?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('panda-mobile-store-switch')) {
    customElements.define('panda-mobile-store-switch', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        if (!details || !summary) return;
        document.addEventListener('pointerdown', (event) => {
          if (details.open && !this.contains(event.target)) details.open = false;
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            const hadFocus = this.contains(document.activeElement);
            details.open = false;
            if (hadFocus) summary.focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (details.open && !this.contains(event.relatedTarget)) details.open = false;
        }, options);
        this.addEventListener('click', (event) => {
          if (event.target.closest('a')) details.open = false;
        }, options);
        matchMedia('(max-width: 749px)').addEventListener('change', () => {
          details.open = false;
        }, options);
      }

      disconnectedCallback() {
        this.events?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manualdeuso"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panda-adults-manual')) {
  customElements.define('panda-adults-manual', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.initialize(options), {...options,once:true});
      else this.initialize(options);
    }

    initialize(options) {
      if (!this.isConnected) return;
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      this.chapters = [...this.querySelectorAll('[data-chapter]')];
      this.items = [...this.querySelectorAll('[data-manual-item]')];
      this.nav = [...this.querySelectorAll('[data-nav]')];
      this.details = [...this.querySelectorAll('details[data-manual-item],details[data-manual-detail]')];
      this.search = this.querySelector('[data-search]');
      this.querySelector('[data-tools]').hidden = false;
      this.records = this.items.map(node => ({node,text:this.normalize(node.textContent + ' ' + (node.dataset.keywords || ''))}));
      this.search.addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.filter(this.search.value), 100);
      },options);
      this.search.addEventListener('keydown', event => {if(event.key === 'Escape') this.clearSearch(true);},options);
      this.querySelector('[data-clear]').addEventListener('click', () => this.clearSearch(true),options);
      this.querySelector('[data-reset-search]').addEventListener('click', () => this.clearSearch(true),options);
      this.querySelectorAll('[data-suggest]').forEach(button => button.addEventListener('click', () => {
        this.search.value = button.dataset.suggest;
        this.filter(this.search.value);
        const first = this.chapters.find(chapter => !chapter.hidden);
        if (first) first.scrollIntoView({behavior:this.motionEnabled?'smooth':'instant',block:'start'});
      },options));
      this.querySelector('[data-expand]').addEventListener('click', () => {this.details.filter(node=>!node.closest('[data-manual-item]').hidden).forEach(node=>{node.open=true;});},options);
      this.querySelector('[data-collapse]').addEventListener('click', () => {this.details.filter(node=>!node.closest('[data-manual-item]').hidden).forEach(node=>{node.open=false;});},options);
      this.querySelectorAll('[data-jump]').forEach(link => link.addEventListener('click', event => {
        let target;
        try {target = document.getElementById(decodeURIComponent(link.hash.slice(1)));} catch (_) {return;}
        if (!target || (target !== this && !this.contains(target))) return;
        event.preventDefault();
        this.clearSearch(false);
        if (target.dataset.chapter) this.setActive(target.dataset.chapter);
        target.scrollIntoView({behavior:this.motionEnabled?'smooth':'instant',block:'start'});
        try {history.replaceState(null,'',link.hash);} catch (_) {}
        const heading=target.querySelector('h1,h2');
        if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}
      },options));
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-manual-item]');
        if (!item || !this.contains(item)) return;
        this.clearSearch(false);
        if(item.tagName==='DETAILS')item.open=true;
        item.querySelectorAll('[data-manual-detail]').forEach(detail=>{detail.open=true;});
        this.setActive(item.closest('[data-chapter]').dataset.chapter);
      },options);
      window.addEventListener('hashchange', () => this.openHash(),options);
      this.setupProgress(options);
      this.setupCopy(options);
      this.setupButtons(options);
      this.setupLights(options);
      this.setupObservers(options);
      this.setActive(this.chapters[0]?.dataset.chapter);
      this.openHash();
      this.motionQuery.addEventListener('change', () => {
        this.animations.forEach(animation=>animation.cancel());
        this.querySelectorAll('[data-led-play]').forEach(button=>{button.hidden=!this.motionEnabled;});
      },options);
    }

    get motionEnabled(){return this.dataset.animations !== 'false' && !this.motionQuery?.matches;}
    normalize(value){return value.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();}

    filter(value) {
      const words=this.normalize(value).split(' ').filter(Boolean);
      if(words.length && !this.openBeforeSearch)this.openBeforeSearch=new Map(this.details.map(node=>[node,node.open]));
      let count=0;
      this.records.forEach(({node,text})=>{
        const visible=words.every(word=>text.includes(word));
        node.hidden=!visible;
        if(visible){
          count++;
          if(words.length){
            if(node.tagName==='DETAILS')node.open=true;
            node.querySelectorAll('[data-manual-detail]').forEach(detail=>{detail.open=true;});
          }
        }
      });
      if(!words.length && this.openBeforeSearch){this.openBeforeSearch.forEach((open,node)=>{node.open=open;});this.openBeforeSearch=null;}
      this.chapters.forEach(chapter=>{
        chapter.hidden=words.length>0 && ![...chapter.querySelectorAll('[data-manual-item]')].some(node=>!node.hidden);
        const link=this.nav.find(node=>node.dataset.nav===chapter.dataset.chapter);
        if(link)link.hidden=chapter.hidden;
      });
      this.querySelector('[data-clear]').hidden=!value;
      this.querySelector('[data-no-results]').hidden=count!==0;
      this.querySelector('[data-search-status]').textContent=words.length?`${count} ${count===1?'tema encontrado':'temas encontrados'}`:'';
      this.dataset.searching=String(words.length>0);
      this.querySelectorAll('[data-chapter-visual]').forEach(node=>{node.hidden=words.length>0;});
      this.updateButtonVisibility(words.length>0);
      const first=this.chapters.find(chapter=>!chapter.hidden);
      this.setActive(first?.dataset.chapter);
    }

    clearSearch(focus) {
      clearTimeout(this.searchTimer);
      this.search.value='';
      this.filter('');
      if(focus)this.search.focus({preventScroll:true});
    }

    openHash() {
      if(!location.hash)return;
      let target;
      try {target=document.getElementById(decodeURIComponent(location.hash.slice(1)));} catch(_){return;}
      if(!target || !this.contains(target))return;
      this.clearSearch(false);
      const detail=target.closest('details');if(detail)detail.open=true;
      const chapter=target.closest('[data-chapter]');if(chapter)this.setActive(chapter.dataset.chapter);
    }

    setActive(key) {
      this.nav.forEach(link=>{
        if(link.dataset.nav===key)link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
      const link=this.nav.find(item=>item.dataset.nav===key);
      const track=this.querySelector('.pm__nav-list');
      if(link && track.scrollWidth>track.clientWidth){
        const offset=link.getBoundingClientRect().left-track.getBoundingClientRect().left;
        if(offset<0 || offset+link.offsetWidth>track.clientWidth)track.scrollTo({left:track.scrollLeft+offset-16,behavior:'instant'});
      }
    }

    setupProgress(options) {
      this.checks=[...this.querySelectorAll('[data-step-check]')];
      if(!this.checks.length)return;
      this.querySelector('[data-progress-wrap]').hidden=false;
      this.querySelectorAll('[data-check-wrap]').forEach(node=>{node.hidden=false;});
      let complete=[];
      try {const data=JSON.parse(localStorage.getItem(this.dataset.storageKey)||'[]');if(Array.isArray(data))complete=data;} catch (_) {}
      this.checks.forEach(input=>{
        input.checked=complete.includes(input.dataset.stepCheck);
        input.addEventListener('change',()=>this.updateProgress(true),options);
      });
      this.querySelector('[data-reset-progress]').addEventListener('click',()=>{this.checks.forEach(input=>{input.checked=false;});this.updateProgress(true);},options);
      this.updateProgress(false);
    }

    updateProgress(save) {
      const done=this.checks.filter(input=>input.checked);
      this.querySelector('[data-progress]').value=done.length;
      this.querySelector('[data-progress-count]').textContent=`${done.length} / ${this.checks.length}`;
      this.checks.forEach(input=>input.closest('.pm__step').classList.toggle('is-complete',input.checked));
      if(save){try{localStorage.setItem(this.dataset.storageKey,JSON.stringify(done.map(input=>input.dataset.stepCheck)));}catch(_){}}
    }

    setupCopy(options) {
      const button=this.querySelector('[data-copy]');
      if(!button)return;
      button.hidden=false;
      button.addEventListener('click',async()=>{
        const message=this.querySelector('[data-support-message]');
        const status=this.querySelector('[data-copy-status]');
        try {
          if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(message.value);
          status.textContent=button.dataset.done;
        } catch(_) {
          message.focus();message.select();
          status.textContent=button.dataset.fallback;
        }
      },options);
    }

    setupButtons(options) {
      this.buttonTabs=[...this.querySelectorAll('[data-button-tab]')];
      this.selectedButton='green';
      this.querySelectorAll('[data-button-panel]').forEach(panel=>{
        panel.setAttribute('role','tabpanel');
        panel.setAttribute('aria-labelledby',`${this.id}-tab-${panel.dataset.buttonPanel}`);
        panel.tabIndex=0;
      });
      const select=(tab,focus)=>{
        this.selectedButton=tab.dataset.buttonTab;
        this.updateButtonVisibility(false);
        if(focus)tab.focus();
      };
      this.buttonTabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>select(tab,false),options);
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=this.buttonTabs[(index+1)%this.buttonTabs.length];
          if(event.key==='ArrowLeft')next=this.buttonTabs[(index+this.buttonTabs.length-1)%this.buttonTabs.length];
          if(event.key==='Home')next=this.buttonTabs[0];
          if(event.key==='End')next=this.buttonTabs.at(-1);
          if(next){event.preventDefault();select(next,true);}
        },options);
      });
      this.updateButtonVisibility(false);
    }

    updateButtonVisibility(searching) {
      if(!this.buttonTabs)return;
      this.querySelectorAll('[data-button-tabs]').forEach(tabs=>{tabs.hidden=searching;});
      this.buttonTabs.forEach(tab=>{
        const active=tab.dataset.buttonTab===this.selectedButton;
        tab.setAttribute('aria-selected',String(active));
        tab.tabIndex=active?0:-1;
      });
      this.querySelectorAll('[data-button-panel]').forEach(panel=>{panel.hidden=!searching && panel.dataset.buttonPanel!==this.selectedButton;});
    }

    setupLights(options) {
      this.activeSignals=new Map();
      this.querySelectorAll('[data-led-play]').forEach(button=>{
        button.hidden=!this.motionEnabled;
        button.setAttribute('aria-pressed','false');
        button.addEventListener('click',()=>{
          const running=this.activeSignals.get(button);
          if(running){running.cancel();return;}
          if(!this.motionEnabled)return;
          const bulb=button.closest('[data-led-card]').querySelector('[data-led-bulb]');
          if(!bulb.animate)return;
          const type=Number(button.dataset.ledPlay);
          let duration,frames=[];
          if(type===3 || type===6){duration=2000;frames=[{opacity:1},{opacity:1}];}
          else {
            const interval=type===1?5000:1000;
            const count=type===1?2:type===2?5:type===4?4:1;
            duration=type===1?6000:type===5?1500:count*interval;
            for(let i=0;i<count;i++){
              const time=i*interval;
              if(time>0)frames.push({offset:(time-1)/duration,opacity:.12});
              frames.push({offset:time/duration,opacity:1});
              frames.push({offset:(time+350)/duration,opacity:1});
              frames.push({offset:(time+351)/duration,opacity:.12});
            }
            frames.push({offset:1,opacity:.12});
          }
          const animation=bulb.animate(frames,{duration,easing:'linear'});
          this.activeSignals.set(button,animation);this.animations.add(animation);
          button.setAttribute('aria-pressed','true');
          button.innerHTML='<span aria-hidden="true">■</span> Detener';
          const status=button.closest('[data-led-card]').querySelector('[data-led-status]');
          status.textContent='Mostrando la señal de esta tarjeta.';
          animation.finished.catch(()=>{}).finally(()=>{
            this.activeSignals.delete(button);this.animations.delete(animation);
            button.setAttribute('aria-pressed','false');
            button.innerHTML='<span aria-hidden="true">▶</span> Ver señal';
            status.textContent='Señal detenida. Podés volver a verla.';
          });
        },options);
      });
    }

    syncNavigation() {
      const offset=parseFloat(getComputedStyle(this).getPropertyValue('--pm-offset')) || 0;
      const boundary=offset+(matchMedia('(max-width:749px)').matches?104:24);
      const visible=this.chapters.filter(chapter=>!chapter.hidden);
      let current=visible[0];
      for(const chapter of visible){if(chapter.getBoundingClientRect().top<=boundary)current=chapter;}
      this.setActive(current?.dataset.chapter);
    }

    setupObservers(options) {
      const schedule=()=>{
        if(this.navFrame)return;
        this.navFrame=requestAnimationFrame(()=>{this.navFrame=null;this.syncNavigation();});
      };
      window.addEventListener('scroll',schedule,{...options,passive:true});
      window.addEventListener('resize',schedule,options);
      this.syncNavigation();
      if(!('IntersectionObserver' in window))return;
      if(!this.motionEnabled)return;
      this.revealObserver=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(!entry.isIntersecting)return;
          this.revealObserver.unobserve(entry.target);
          if(!this.motionEnabled || !entry.target.animate)return;
          const animation=entry.target.animate([{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:600,easing:'cubic-bezier(.22,1,.36,1)'});
          this.animations.add(animation);
          animation.finished.catch(()=>{}).finally(()=>this.animations.delete(animation));
        });
      },{threshold:.08});
      this.querySelectorAll('.pm__quick>a,.pm__chapter-heading,.pm__step,.pm__light-card,.pm__sos-map,.pm__kit,.pm__connection,.pm__support').forEach(node=>this.revealObserver.observe(node));
    }

    cleanup(){
      this.events?.abort();clearTimeout(this.searchTimer);cancelAnimationFrame(this.navFrame);this.navFrame=null;
      this.navObserver?.disconnect();this.revealObserver?.disconnect();
      this.animations?.forEach(animation=>animation.cancel());
      this.openBeforeSearch=null;
    }
    disconnectedCallback(){this.cleanup();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pregfrecu"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panda-store-faq')) {
  customElements.define('panda-store-faq', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.items = [...this.querySelectorAll('[data-sfaq-item]')];
      this.items.forEach(item => {
        item.querySelector('summary')?.addEventListener('click', event => {
          event.preventDefault();
          this.toggle(item, !item.open);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-sfaq-item]');
        if (item) this.toggle(item, true);
      }, options);
    }

    get motionEnabled() {
      return this.dataset.animations !== 'false' && !this.motionQuery?.matches;
    }

    toggle(item, open) {
      if (open) this.items.forEach(other => {if (other !== item && other.open) this.toggle(other, false);});
      const answer = item.querySelector('.pa-sfaq__answer');
      if (!this.motionEnabled || !answer?.animate) {item.open = open; return;}
      item.currentAnimation?.cancel();
      if (open) {
        item.open = true;
        item.currentAnimation = answer.animate([{height: '0px', opacity: 0}, {height: answer.scrollHeight + 'px', opacity: 1}], {duration: 360, easing: 'cubic-bezier(.22,1,.36,1)'});
      } else {
        const animation = answer.animate([{height: answer.scrollHeight + 'px', opacity: 1}, {height: '0px', opacity: 0}], {duration: 260, easing: 'ease-in'});
        item.currentAnimation = animation;
        animation.onfinish = () => {item.open = false; item.currentAnimation = null;};
      }
    }

    disconnectedCallback() {this.events?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productoprincipal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panda-adults-pdp')) {
  customElements.define('panda-adults-pdp', class extends HTMLElement {
    connectedCallback() {
      this.stopEnhancements();
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(options), {...options, once: true});
      } else {
        this.initialize(options);
      }
    }

    initialize(options) {
      if (!this.isConnected) return;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      this.panels = [...this.querySelectorAll('[data-offer-panel]')];
      this.media = [...this.querySelectorAll('[data-offer-media]')];
      this.choices = [...this.querySelectorAll('[data-offer-choice]')];
      this.choices.forEach(input => input.addEventListener('change', () => {
        if (input.checked) this.activateOffer(input.value);
      }, options));
      this.panels.forEach(panel => {
        panel.querySelector('[data-variant-select]')?.addEventListener('change', () => this.updateVariant(panel, true), options);
        panel.querySelector('form')?.addEventListener('submit', event => this.addToCart(event), options);
        this.updateVariant(panel);
      });
      const selected = this.panels.find(panel => panel.dataset.offerPanel === this.dataset.defaultOffer) || this.panels[0];
      if (selected) this.activateOffer(selected.dataset.offerPanel);
      const picker = this.querySelector('[data-offer-picker]');
      if (picker) picker.hidden = this.panels.length < 2;
      this.setupPurchaseDetails(options);
      this.setupReviews(options);
      this.setupGallery(options);
      this.setupReveals();
      this.setupBattery();
      this.setupEta();
      this.querySelectorAll('[data-scroll-buy], [data-battery-jump]').forEach(link => link.addEventListener('click', event => {
        const target = this.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'start'});
      }, options));
      this.motionQuery.addEventListener('change', () => {
        this.animations.forEach(animation => animation.cancel());
      }, options);
      // Si vuelven atrás desde el checkout, el navegador restaura la página: reactivamos los botones.
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        this.cartPending = false;
        this.choices.forEach(choice => {choice.disabled = false;});
        this.panels.forEach(panel => {
          panel.querySelectorAll('[data-variant-select], [data-quantity]').forEach(field => {field.disabled = false;});
          this.updateVariant(panel);
        });
      }, options);
    }

    setupEta() {
      const node = this.querySelector('[data-eta]');
      if (!node) return;
      const min = Number(node.dataset.min) || 0;
      const max = Number(node.dataset.max) || 0;
      if (min < 1 || max < min) return;
      const cutoff = Number(node.dataset.cutoff);
      const start = new Date();
      if (Number.isFinite(cutoff) && start.getHours() >= cutoff) start.setDate(start.getDate() + 1);
      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          const day = result.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return result;
      };
      let format;
      try {
        const formatter = new Intl.DateTimeFormat('es-AR', {weekday: 'short', day: 'numeric', month: 'short'});
        format = date => formatter.format(date).replace(/\./g, '');
      } catch (_) {
        format = date => `${date.getDate()}/${date.getMonth() + 1}`;
      }
      const escapeHtml = value => value.replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
      const from = `<strong>${escapeHtml(format(addBusinessDays(start, min)))}</strong>`;
      const to = `<strong>${escapeHtml(format(addBusinessDays(start, max)))}</strong>`;
      const template = escapeHtml(node.dataset.template || 'Recibilo entre el {min} y el {max}');
      node.querySelector('[data-eta-text]').innerHTML = template.replace('{min}', from).replace('{max}', to);
      node.hidden = false;
    }

    setupPurchaseDetails(options) {
      const details = [...this.querySelectorAll('.pa-pdp__details details')];
      details.forEach(detail => detail.addEventListener('toggle', () => {
        if (detail.open) details.forEach(other => {if (other !== detail) other.open = false;});
      }, options));
      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.querySelector('[data-sticky-buy]')?.addEventListener('click', () => {
        const panel = this.panels.find(item => item.dataset.offerPanel === this.activeOffer);
        const form = panel?.querySelector('form');
        const button = panel?.querySelector('[data-add-button]');
        if (form && button && !button.disabled) form.requestSubmit(button);
        else this.querySelector('.pa-pdp__purchase')?.scrollIntoView({behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'center'});
      }, options);
      const buyArea = this.querySelector('.pa-pdp__purchase');
      if ('IntersectionObserver' in window && this.stickyBar && buyArea && this.dataset.sticky === 'true') {
        const update = () => {
          const purchase = buyArea.getBoundingClientRect();
          this.stickyBar.hidden = !this.panels.length || purchase.bottom > 0 || this.getBoundingClientRect().bottom < 120;
        };
        this.purchaseObserver = new IntersectionObserver(update);
        this.purchaseObserver.observe(buyArea);
        this.stickyObserver = new IntersectionObserver(entries => {if (!entries[0].isIntersecting) this.stickyBar.hidden = true;});
        this.stickyObserver.observe(this);
        window.addEventListener('scroll', () => {
          if (this.stickyFrame) return;
          this.stickyFrame = requestAnimationFrame(() => {
            this.stickyFrame = null;
            update();
          });
        }, {...options, passive:true});
      }
      this.syncSticky();
    }

    syncSticky() {
      const panel = this.panels?.find(item => item.dataset.offerPanel === this.activeOffer);
      const bar = this.querySelector('[data-sticky-bar]');
      if (!panel || !bar) return;
      bar.querySelector('[data-sticky-name]').textContent = panel.querySelector('[data-selected-name]')?.textContent || '';
      bar.querySelector('[data-sticky-price]').textContent = panel.querySelector('[data-product-price]')?.textContent || '';
      const button = bar.querySelector('[data-sticky-buy]');
      const original = panel.querySelector('[data-add-button]');
      button.disabled = this.cartPending || Boolean(original?.disabled);
      button.textContent = original?.textContent || 'Elegir opciones';
    }

    get motionEnabled() {
      return this.dataset.animations !== 'false' && !this.motionQuery?.matches;
    }

    reveal(node, delay = 0) {
      if (!node || !this.motionEnabled || !node.animate) return;
      const animation = node.animate([
        {opacity: 0, transform: 'translateY(16px)'},
        {opacity: 1, transform: 'translateY(0)'}
      ], {duration: 650, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards'});
      this.animations.add(animation);
      animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
    }

    setupReveals() {
      if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
      const targets = [...this.querySelectorAll('.pa-pdp__visuals, .pa-pdp__purchase > :not(.pa-pdp__offer-panel):not([data-eta]), .pa-pdp-battery-hero__copy, .pa-pdp-battery-hero__timeline, .pa-pdp__community-head, .pa-pdp__community-grid, .pa-pdp__faq-list, .pa-pdp__final-inner')];
      this.revealObserver = new IntersectionObserver(entries => {
        let order = 0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.revealObserver.unobserve(entry.target);
          this.reveal(entry.target, Math.min(order++ * 55, 220));
        });
      }, {threshold: 0.08});
      targets.forEach(node => this.revealObserver.observe(node));
    }

    setupGallery(options) {
      this.querySelectorAll('[data-offer-thumbs]').forEach(strip => {
        const key = strip.dataset.offerThumbs;
        const figure = this.querySelector(`.pa-pdp__product-media[data-offer-media="${key}"]`);
        const swap = figure?.querySelector('[data-swap]');
        const thumbs = [...strip.querySelectorAll('[data-thumb]')];
        if (!figure || !swap || thumbs.length < 2) return;
        let current = 0;
        const select = index => {
          current = (index + thumbs.length) % thumbs.length;
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === current);
            thumb.setAttribute('aria-pressed', String(i === current));
          });
          const thumb = thumbs[current];
          thumb.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: this.motionEnabled ? 'smooth' : 'instant'});
          if (current === 0) {
            swap.hidden = true;
            figure.classList.remove('is-swapped');
            return;
          }
          swap.srcset = thumb.dataset.srcset || '';
          swap.sizes = '(max-width: 749px) 90vw, 50vw';
          swap.src = thumb.dataset.full;
          swap.alt = thumb.dataset.alt || '';
          swap.hidden = false;
          figure.classList.add('is-swapped');
          swap.classList.remove('is-in');
          void swap.offsetWidth;
          swap.classList.add('is-in');
        };
        figure.paSelect = select;
        thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i), options));
        figure.querySelector('[data-gallery-prev]')?.addEventListener('click', () => select(current - 1), options);
        figure.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(current + 1), options);
        let startX = null;
        figure.addEventListener('touchstart', event => {startX = event.touches[0].clientX;}, {...options, passive: true});
        figure.addEventListener('touchend', event => {
          if (startX === null) return;
          const dx = event.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) select(current + (dx < 0 ? 1 : -1));
        }, {...options, passive: true});
      });
    }

    setupReviews(options) {
      const dialog = this.querySelector('[data-reviews-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      this.reviewsDialog = dialog;
      this.querySelectorAll('[data-reviews-open]').forEach(button => button.addEventListener('click', () => this.openReviews(button), options));
      dialog.querySelector('[data-reviews-close]')?.addEventListener('click', () => this.closeReviews(), options);
      dialog.addEventListener('click', event => {if (event.target === dialog) this.closeReviews();}, options);
      dialog.addEventListener('cancel', event => {event.preventDefault(); this.closeReviews();}, options);
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('pa-scroll-lock');
        this.reviewsOpener?.focus({preventScroll: true});
      }, options);
      dialog.querySelector('[data-reviews-buy]')?.addEventListener('click', () => {
        this.closeReviews();
        this.querySelector('.pa-pdp__purchase')?.scrollIntoView({behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'start'});
      }, options);
      this.addEventListener('shopify:block:select', event => {if (event.target.closest('[data-reviews-dialog]')) this.openReviews();}, options);
    }

    openReviews(opener) {
      const dialog = this.reviewsDialog;
      if (!dialog || dialog.open) return;
      this.reviewsOpener = opener || null;
      dialog.classList.remove('is-closing');
      dialog.showModal();
      document.documentElement.classList.add('pa-scroll-lock');
      const list = dialog.querySelector('.pa-pdp-reviews__list');
      if (list) list.scrollTop = 0;
    }

    closeReviews() {
      const dialog = this.reviewsDialog;
      if (!dialog?.open || dialog.classList.contains('is-closing')) return;
      if (!this.motionEnabled) {dialog.close(); return;}
      const sheet = dialog.querySelector('.pa-pdp-reviews__sheet');
      dialog.classList.add('is-closing');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        dialog.classList.remove('is-closing');
        dialog.close();
      };
      sheet?.addEventListener('animationend', event => {if (event.target === sheet) finish();});
      setTimeout(finish, 360);
    }

    stopEnhancements() {
      this.revealObserver?.disconnect();
      this.batteryObserver?.disconnect();
      this.purchaseObserver?.disconnect();
      this.stickyObserver?.disconnect();
      cancelAnimationFrame(this.stickyFrame);
      this.animations?.forEach(animation => animation.cancel());
      if (this.reviewsDialog?.open) this.reviewsDialog.close();
      document.documentElement.classList.remove('pa-scroll-lock');
    }

    activateOffer(key) {
      if (this.cartPending || !this.panels.some(panel => panel.dataset.offerPanel === key)) return;
      const changed = this.activeOffer && this.activeOffer !== key;
      this.activeOffer = key;
      this.panels.forEach(panel => {panel.hidden = panel.dataset.offerPanel !== key;});
      this.media.forEach(media => {media.hidden = media.dataset.offerMedia !== key;});
      this.choices.forEach(choice => {choice.checked = choice.value === key;});
      const hasDuoShip = Boolean(this.querySelector('[data-ship-offer="duo"]'));
      this.querySelectorAll('[data-ship-offer]').forEach(node => {
        node.hidden = hasDuoShip ? node.dataset.shipOffer !== key : false;
      });
      this.querySelector('[data-sticky-cart]')?.setAttribute('hidden', '');
      this.syncSticky();
      if (changed) {
        this.reveal(this.media.find(media => media.dataset.offerMedia === key));
        this.reveal(this.panels.find(panel => panel.dataset.offerPanel === key), 45);
      }
    }

    setupBattery() {
      const block = this.querySelector('[data-battery]');
      if (!block) return;
      const counters = [...block.querySelectorAll('[data-count]')];
      if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
      block.classList.add('is-armed');
      const run = () => {
        block.classList.add('is-visible');
        counters.forEach(node => {
          const target = parseFloat(node.dataset.count);
          if (!Number.isFinite(target)) return;
          const start = performance.now();
          const duration = 1400;
          const tick = now => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            node.textContent = String(Math.round(target * eased));
            if (progress < 1 && this.isConnected) requestAnimationFrame(tick);
            else node.textContent = node.dataset.count;
          };
          node.textContent = '0';
          requestAnimationFrame(tick);
        });
      };
      this.batteryObserver = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return;
        this.batteryObserver.disconnect();
        run();
      }, {threshold: 0.3});
      this.batteryObserver.observe(block);
    }

    updateVariant(panel, fromUser = false) {
      const option = panel.querySelector('[data-variant-select]')?.selectedOptions[0];
      if (!option) return;
      const price = panel.querySelector('[data-product-price]');
      const compare = panel.querySelector('[data-product-compare]');
      const installment = panel.querySelector('[data-installment]');
      const button = panel.querySelector('[data-add-button]');
      const quantity = panel.querySelector('[data-quantity]');
      if (price) price.textContent = option.dataset.price;
      if (compare) {compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;}
      if (installment && option.dataset.installment) installment.textContent = option.dataset.installment;
      const save = panel.querySelector('[data-product-save]');
      if (save) {save.textContent = option.dataset.save ? `-${option.dataset.save}%` : ''; save.hidden = !option.dataset.save;}
      if (option.dataset.unit) {
        panel.querySelectorAll('[data-unit-price]').forEach(node => {node.textContent = option.dataset.unit;});
        const cardUnit = this.querySelector('[data-offer-card-unit="' + panel.dataset.offerPanel + '"]');
        if (cardUnit) cardUnit.textContent = option.dataset.unit + ' c/u';
      }
      const stockNote = panel.querySelector('[data-stock-note]');
      if (stockNote) {
        const limit = Number(panel.dataset.lowStock) || 0;
        const stock = option.dataset.stock === '' ? NaN : Number(option.dataset.stock);
        const show = limit > 0 && Number.isFinite(stock) && stock > 0 && stock <= limit && option.dataset.available === 'true';
        stockNote.hidden = !show;
        if (show) stockNote.querySelector('[data-stock-text]').textContent = stock === 1 ? 'Queda 1 unidad' : `Quedan ${stock} unidades`;
      }
      if (fromUser && panel.dataset.pageProduct === 'true' && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      }
      if (button) {button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Agotado' : button.dataset.label;}
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        quantity.value = quantity.min;
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
      }
      const cardPrice = this.querySelector('[data-offer-card-price="' + panel.dataset.offerPanel + '"]');
      if (cardPrice) cardPrice.textContent = option.dataset.price;
      const media = this.media.find(node => node.dataset.offerMedia === panel.dataset.offerPanel);
      media?.paSelect?.(0);
      if (media && media.dataset.customImage !== 'true' && option.dataset.image) {
        media.querySelectorAll('.pa-pdp__product-image').forEach(image => {
          if (image.getAttribute('src') !== option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
          image.alt = option.dataset.alt || '';
        });
      }
      const feedback = panel.querySelector('[data-cart-feedback]');
      if (feedback) feedback.hidden = true;
      this.syncSticky();
    }

    async addToCart(event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (this.cartPending || !form?.reportValidity()) return;
      const panel = form.closest('[data-offer-panel]');
      const button = form.querySelector('[data-add-button]');
      if (!panel || !button || button.disabled) return;
      const select = form.querySelector('[data-variant-select]');
      const quantity = form.querySelector('[data-quantity]');
      const feedback = panel.querySelector('[data-cart-feedback]');
      const message = panel.querySelector('[data-cart-message]');
      const body = new FormData(form);
      const sectionIds = [...new Set([...document.querySelectorAll('cart-icon, cart-drawer-component, cart-notification, #cart-icon-bubble')]
        .map(node => node.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '')).filter(Boolean))].slice(0, 5);
      if (sectionIds.length) {body.set('sections', sectionIds.join(',')); body.set('sections_url', window.location.pathname);}
      this.cartPending = true;
      button.disabled = true;
      button.textContent = 'Agregando…';
      this.syncSticky();
      if (select) select.disabled = true;
      if (quantity) quantity.disabled = true;
      this.choices.forEach(choice => {choice.disabled = true;});
      if (feedback) {feedback.hidden = true; feedback.classList.remove('has-error');}
      const request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 20000);
      let confirmed = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST', body, headers: {Accept: 'application/json'}, credentials: 'same-origin', signal: request.signal
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const error = new Error(result.description || result.message || 'No se pudo agregar esta opción. Revisá el stock y la cantidad.');
          error.cartResponse = true;
          throw error;
        }
        confirmed = true;
        if (this.dataset.directCheckout !== 'false') {
          button.textContent = 'Yendo al pago…';
          window.location.href = '/checkout';
          return;
        }
        this.querySelector('[data-sticky-cart]')?.removeAttribute('hidden');
        if (feedback) feedback.hidden = false;
        if (message) message.textContent = panel.dataset.offerPanel === 'duo' ? 'Tu pack Dúo se agregó al carrito.' : 'Tu Panda Adults se agregó al carrito.';
        try {this.refreshCartSections(result.sections);} catch (_) {}
      } catch (error) {
        if (!confirmed) {
          if (feedback) {feedback.hidden = false; feedback.classList.add('has-error');}
          if (message) message.textContent = error.cartResponse ? error.message : 'No pudimos confirmar la respuesta. Revisá tu carrito antes de volver a intentar.';
        }
      } finally {
        clearTimeout(timeout);
        if (confirmed && this.dataset.directCheckout !== 'false') return;
        this.cartPending = false;
        if (select) select.disabled = false;
        if (quantity) quantity.disabled = false;
        this.choices.forEach(choice => {choice.disabled = false;});
        const available = select?.selectedOptions[0]?.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.label : 'Agotado';
        this.syncSticky();
      }
    }

    refreshCartSections(sections) {
      if (!sections) return;
      for (const html of Object.values(sections)) {
        if (typeof html !== 'string') continue;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        for (const selector of ['cart-icon', 'cart-drawer-component', 'cart-notification', '#cart-icon-bubble']) {
          const current = document.querySelector(selector);
          const replacement = parsed.querySelector(selector);
          if (current && replacement) current.replaceWith(replacement);
        }
      }
    }

    disconnectedCallback() {this.events?.abort(); this.stopEnhancements();}
  });
}

if(!customElements.get('panda-use-stories-v2')){
 customElements.define('panda-use-stories-v2',class extends HTMLElement{
  connectedCallback(){
   this.events?.abort();this.events=new AbortController();const options={signal:this.events.signal};
   const init=()=>{if(!this.isConnected)return;this.track=this.querySelector('[data-track]');this.cards=[...this.querySelectorAll('[data-card]')];this.controls=this.querySelector('[data-controls]');this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.count=this.querySelector('[data-count]');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.progress=this.querySelector('[data-progress]');this.animations=new Set();if(!this.track||!this.cards.length)return;this.setupMotion(options);
    this.prev.addEventListener('click',()=>this.move(-1),options);this.next.addEventListener('click',()=>this.move(1),options);
    this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.sync());},{...options,passive:true});
    this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}if(e.key==='Home'||e.key==='End'){e.preventDefault();this.go(e.key==='Home'?0:this.cards.length-1);}},options);
    this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('[data-card]');const i=this.cards.indexOf(card);if(i>=0)this.go(i);},options);
    if('ResizeObserver' in window){this.resize=new ResizeObserver(()=>this.sync());this.resize.observe(this.track);}this.sync();
   };if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init,{...options,once:true});}else{init();}
  }
  positions(){const base=this.track.getBoundingClientRect().left;const max=this.track.scrollWidth-this.track.clientWidth;return this.cards.map(c=>Math.max(0,Math.min(max,c.getBoundingClientRect().left-base+this.track.scrollLeft)));}
  sync(){const max=this.track.scrollWidth-this.track.clientWidth;this.controls.hidden=max<3;const x=this.track.scrollLeft;this.prev.disabled=x<=2;this.next.disabled=x>=max-2;const positions=this.positions();let index=0;positions.forEach((p,i)=>{if(Math.abs(p-x)<Math.abs(positions[index]-x))index=i;});if(x>=max-2&&max>2)index=this.cards.length-1;const label=String(index+1).padStart(2,'0')+' / '+String(this.cards.length).padStart(2,'0');if(this.count.textContent!==label)this.count.textContent=label;if(this.progress){const fraction=max>2?Math.min(1,Math.max(.12,(x+this.track.clientWidth)/this.track.scrollWidth)):1;this.progress.style.transform='scaleX('+fraction+')';}}
  move(direction){const x=this.track.scrollLeft;const positions=this.positions();const target=direction>0?positions.find(p=>p>x+3):positions.slice().reverse().find(p=>p<x-3);if(target!==undefined)this.scroll(target);}
  go(i){const p=this.positions()[i];if(p!==undefined)this.scroll(p);}
  scroll(left){this.track.scrollTo({left,behavior:this.reduced.matches||this.dataset.motion==='false'?'instant':'smooth'});}
  get motionEnabled(){return this.dataset.motion!=='false'&&!this.reduced.matches;}
  animateNode(node,frames,options){if(!this.motionEnabled||!node?.animate)return;const a=node.animate(frames,options);this.animations.add(a);a.finished.catch(()=>{}).finally(()=>this.animations.delete(a));}
  setupMotion(options){
   this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.animations.forEach(a=>a.cancel());},options);
   if('IntersectionObserver' in window){
    this.reveals=new IntersectionObserver(entries=>{let delay=0;entries.forEach(e=>{if(!e.isIntersecting)return;this.reveals.unobserve(e.target);this.animateNode(e.target,[{opacity:0,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}],{duration:680,delay:delay,easing:'cubic-bezier(.2,.75,.25,1)',fill:'backwards'});delay+=75;});},{threshold:.12});
    [this.querySelector('.pa-stories__heading'),...this.cards].filter(Boolean).forEach(n=>this.reveals.observe(n));
   }
   this.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open){this.animateNode(d.querySelector('div'),[{opacity:0,transform:'translateY(-6px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'ease-out'});}},{signal:options.signal}));
  }
  disconnectedCallback(){this.reveals?.disconnect();this.animations?.forEach(a=>a.cancel());this.events?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);}
 });
}

if(!customElements.get('panda-adults-guide-v1')){
 customElements.define('panda-adults-guide-v1',class extends HTMLElement{
  connectedCallback(){
   this.stopEnhancements();this.events?.abort();this.events=new AbortController();
   const options={signal:this.events.signal};
   if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>this.initialize(options),{...options,once:true});}else{this.initialize(options);}
  }
  initialize(options){
   if(!this.isConnected)return;
   this.motionQuery=window.matchMedia('(prefers-reduced-motion: reduce)');this.animations=new Set();
   this.setupCarousel(options);this.setupFeatureTabs(options);this.setupReveals();
   this.motionQuery.addEventListener('change',()=>this.animations.forEach(a=>a.cancel()),options);
  }
  get motionEnabled(){return this.dataset.animations!=='false'&&!this.motionQuery?.matches;}
  reveal(node,delay=0){
   if(!node||!this.motionEnabled||!node.animate)return;
   const a=node.animate([{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,delay,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});
   this.animations.add(a);a.finished.catch(()=>{}).finally(()=>this.animations.delete(a));
  }
  setupReveals(){
   if(!this.motionEnabled||!('IntersectionObserver' in window))return;
   const targets=[...this.querySelectorAll('.pa-guide__section-heading, .pa-guide__steps-grid')];
   this.revealObserver=new IntersectionObserver(entries=>{let order=0;entries.forEach(entry=>{if(!entry.isIntersecting)return;this.revealObserver.unobserve(entry.target);this.reveal(entry.target,Math.min(order++*55,220));});},{threshold:0.08});
   targets.forEach(node=>this.revealObserver.observe(node));
  }
  setupFeatureTabs(options){
   this.featureTabs=[...this.querySelectorAll('[data-feature-tab]')];
   this.featurePanels=[...this.querySelectorAll('[data-feature-panel]')];
   const tablist=this.querySelector('[data-feature-tabs]');
   if(!tablist)return;
   tablist.hidden=false;
   this.featurePanels.forEach(panel=>{panel.setAttribute('role','tabpanel');panel.setAttribute('tabindex','0');const tab=this.featureTabs.find(t=>t.dataset.featureTab===panel.dataset.featurePanel);if(tab)panel.setAttribute('aria-labelledby',tab.id);});
   this.featureTabs.forEach((tab,index)=>{
    tab.addEventListener('click',()=>this.activateFeature(tab.dataset.featureTab),options);
    tab.addEventListener('keydown',event=>{
     const keys={ArrowRight:(index+1)%this.featureTabs.length,ArrowLeft:(index-1+this.featureTabs.length)%this.featureTabs.length,Home:0,End:this.featureTabs.length-1};
     if(!(event.key in keys))return;event.preventDefault();
     const next=this.featureTabs[keys[event.key]];next.focus({preventScroll:true});next.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});this.activateFeature(next.dataset.featureTab);
    },options);
   });
   this.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-feature-panel]');if(panel)this.activateFeature(panel.dataset.featurePanel);},options);
   this.activateFeature('safety');
  }
  activateFeature(key){
   this.featureTabs.forEach(tab=>{const active=tab.dataset.featureTab===key;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});
   this.featurePanels.forEach(panel=>{panel.hidden=panel.dataset.featurePanel!==key;if(!panel.hidden)this.reveal(panel);});
  }
  setupCarousel(options){
   this.track=this.querySelector('[data-steps-track]');
   if(!this.track)return;
   this.slides=[...this.track.querySelectorAll('[data-step]')];
   this.stepDots=[...this.querySelectorAll('[data-step-dot]')];
   this.stepPrevious=this.querySelector('[data-step-prev]');
   this.stepNext=this.querySelector('[data-step-next]');
   this.stepStatus=this.querySelector('[data-step-status]');
   this.stepControls=this.querySelector('[data-steps-controls]');
   this.mobileQuery=window.matchMedia('(max-width: 749px)');
   this.stepIndex=0;
   this.stepPrevious?.addEventListener('click',()=>this.goToStep(this.stepIndex-1),options);
   this.stepNext?.addEventListener('click',()=>this.goToStep(this.stepIndex+1),options);
   this.stepDots.forEach(dot=>dot.addEventListener('click',()=>this.goToStep(Number(dot.dataset.stepDot)),options));
   this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(()=>this.syncStep());},{...options,passive:true});
   this.track.addEventListener('keydown',event=>{
    if(!this.mobileQuery.matches||event.target!==this.track)return;
    const indices={ArrowLeft:this.stepIndex-1,ArrowRight:this.stepIndex+1,Home:0,End:this.slides.length-1};
    if(!(event.key in indices))return;event.preventDefault();this.goToStep(indices[event.key]);
   },options);
   this.mobileQuery.addEventListener('change',()=>this.resizeCarousel(),options);
   if('ResizeObserver' in window){this.trackObserver=new ResizeObserver(()=>this.resizeCarousel());this.trackObserver.observe(this.track);}else{window.addEventListener('resize',()=>this.resizeCarousel(),options);}
   this.resizeCarousel();
  }
  stepPosition(index){const slide=this.slides[index];const left=slide.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft;return Math.max(0,Math.min(left,this.track.scrollWidth-this.track.clientWidth));}
  goToStep(index,instant=false){if(!this.track||!this.mobileQuery.matches)return;const next=Math.max(0,Math.min(index,this.slides.length-1));this.track.scrollTo({left:this.stepPosition(next),behavior:instant||!this.motionEnabled?'instant':'smooth'});if(instant)this.syncStep();}
  syncStep(){
   if(!this.track||!this.slides.length)return;
   let nearest=0,distance=Infinity;
   this.slides.forEach((slide,index)=>{const offset=Math.abs(this.track.scrollLeft-this.stepPosition(index));if(offset<distance){nearest=index;distance=offset;}});
   this.stepIndex=this.mobileQuery.matches?nearest:0;
   this.slides.forEach((slide,index)=>slide.classList.toggle('is-current',index===this.stepIndex));
   this.stepDots.forEach((dot,index)=>{if(index===this.stepIndex)dot.setAttribute('aria-current','step');else dot.removeAttribute('aria-current');});
   if(this.stepPrevious)this.stepPrevious.disabled=this.stepIndex===0;
   if(this.stepNext)this.stepNext.disabled=this.stepIndex===this.slides.length-1;
   if(this.stepStatus&&this.stepStatus.dataset.index!==String(this.stepIndex)){
    this.stepStatus.dataset.index=String(this.stepIndex);
    this.stepStatus.textContent=`${String(this.stepIndex+1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
    this.stepStatus.setAttribute('aria-label',`Paso ${this.stepIndex+1} de ${this.slides.length}`);
   }
  }
  resizeCarousel(){
   const mobile=this.mobileQuery.matches;
   if(this.stepControls)this.stepControls.hidden=!mobile;
   if(mobile){this.track.setAttribute('tabindex','0');this.track.setAttribute('role','region');this.track.setAttribute('aria-roledescription','carrusel');this.goToStep(this.stepIndex,true);}
   else{this.track.removeAttribute('tabindex');this.track.removeAttribute('role');this.track.removeAttribute('aria-roledescription');this.track.scrollTo({left:0,behavior:'instant'});this.syncStep();}
  }
  stopEnhancements(){this.revealObserver?.disconnect();this.trackObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);this.animations?.forEach(a=>a.cancel());}
  disconnectedCallback(){this.events?.abort();this.stopEnhancements();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productproduct"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panda-adults-guide-v1')) {
 customElements.define('panda-adults-guide-v1',class extends HTMLElement {
  connectedCallback(){
   this.stopEnhancements();this.events?.abort();this.events=new AbortController();
   const options={signal:this.events.signal};
   if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>this.initialize(options),{...options,once:true});}else{this.initialize(options);}
  }
  initialize(options){
   if(!this.isConnected)return;
   this.motionQuery=window.matchMedia('(prefers-reduced-motion: reduce)');this.animations=new Set();
   this.setupCarousel(options);this.setupFeatureTabs(options);this.setupReveals();
   this.motionQuery.addEventListener('change',()=>this.animations.forEach(a=>a.cancel()),options);
  }
    setupFeatureTabs(options) {
      this.featureTabs = [...this.querySelectorAll('[data-feature-tab]')];
      this.featurePanels = [...this.querySelectorAll('[data-feature-panel]')];
      const tablist = this.querySelector('[data-feature-tabs]');
      if (!tablist) return;
      tablist.hidden = false;
      this.featurePanels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
        panel.setAttribute('aria-labelledby', this.featureTabs.find(tab => tab.dataset.featureTab === panel.dataset.featurePanel).id);
      });
      this.featureTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateFeature(tab.dataset.featureTab), options);
        tab.addEventListener('keydown', event => {
          const keys = {ArrowRight: (index + 1) % this.featureTabs.length, ArrowLeft: (index - 1 + this.featureTabs.length) % this.featureTabs.length, Home: 0, End: this.featureTabs.length - 1};
          if (!(event.key in keys)) return;
          event.preventDefault();
          const next = this.featureTabs[keys[event.key]];
          next.focus({preventScroll: true});
          next.scrollIntoView({block:'nearest', inline:'nearest', behavior:'instant'});
          this.activateFeature(next.dataset.featureTab);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-feature-panel]');
        if (panel) this.activateFeature(panel.dataset.featurePanel);
      }, options);
      this.activateFeature('safety');
    }

    activateFeature(key) {
      this.featureTabs.forEach(tab => {
        const active = tab.dataset.featureTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.featurePanels.forEach(panel => {
        panel.hidden = panel.dataset.featurePanel !== key;
        if (!panel.hidden) this.reveal(panel);
      });
    }

    get motionEnabled() {
      return this.dataset.animations !== 'false' && !this.motionQuery?.matches;
    }

    reveal(node, delay = 0) {
      if (!node || !this.motionEnabled || !node.animate) return;
      const animation = node.animate([
        {opacity: 0, transform: 'translateY(16px)'},
        {opacity: 1, transform: 'translateY(0)'}
      ], {duration: 650, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards'});
      this.animations.add(animation);
      animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
    }

    setupReveals() {
      if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
      const targets = [...this.querySelectorAll('.pa-guide__section-heading, .pa-guide__steps-grid')];
      this.revealObserver = new IntersectionObserver(entries => {
        let order = 0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.revealObserver.unobserve(entry.target);
          this.reveal(entry.target, Math.min(order++ * 55, 220));
        });
      }, {threshold: 0.08});
      targets.forEach(node => this.revealObserver.observe(node));
    }

    setupCarousel(options) {
      this.track = this.querySelector('[data-steps-track]');
      if (!this.track) return;
      this.slides = [...this.track.querySelectorAll('[data-step]')];
      this.stepDots = [...this.querySelectorAll('[data-step-dot]')];
      this.stepPrevious = this.querySelector('[data-step-prev]');
      this.stepNext = this.querySelector('[data-step-next]');
      this.stepStatus = this.querySelector('[data-step-status]');
      this.stepControls = this.querySelector('[data-steps-controls]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.stepIndex = 0;
      this.stepPrevious?.addEventListener('click', () => this.goToStep(this.stepIndex - 1), options);
      this.stepNext?.addEventListener('click', () => this.goToStep(this.stepIndex + 1), options);
      this.stepDots.forEach(dot => dot.addEventListener('click', () => this.goToStep(Number(dot.dataset.stepDot)), options));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.syncStep());
      }, {...options, passive: true});
      this.track.addEventListener('keydown', event => {
        if (!this.mobileQuery.matches || event.target !== this.track) return;
        const indices = {ArrowLeft: this.stepIndex - 1, ArrowRight: this.stepIndex + 1, Home: 0, End: this.slides.length - 1};
        if (!(event.key in indices)) return;
        event.preventDefault();
        this.goToStep(indices[event.key]);
      }, options);
      this.mobileQuery.addEventListener('change', () => this.resizeCarousel(), options);
      if ('ResizeObserver' in window) {
        this.trackObserver = new ResizeObserver(() => this.resizeCarousel());
        this.trackObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.resizeCarousel(), options);
      }
      this.resizeCarousel();
    }

    stepPosition(index) {
      const slide = this.slides[index];
      const left = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      return Math.max(0, Math.min(left, this.track.scrollWidth - this.track.clientWidth));
    }

    goToStep(index, instant = false) {
      if (!this.track || !this.mobileQuery.matches) return;
      const next = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({left: this.stepPosition(next), behavior: instant || !this.motionEnabled ? 'instant' : 'smooth'});
      if (instant) this.syncStep();
    }

    syncStep() {
      if (!this.track || !this.slides.length) return;
      let nearest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const offset = Math.abs(this.track.scrollLeft - this.stepPosition(index));
        if (offset < distance) {nearest = index; distance = offset;}
      });
      this.stepIndex = this.mobileQuery.matches ? nearest : 0;
      this.slides.forEach((slide, index) => slide.classList.toggle('is-current', index === this.stepIndex));
      this.stepDots.forEach((dot, index) => {
        if (index === this.stepIndex) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      });
      if (this.stepPrevious) this.stepPrevious.disabled = this.stepIndex === 0;
      if (this.stepNext) this.stepNext.disabled = this.stepIndex === this.slides.length - 1;
      if (this.stepStatus && this.stepStatus.dataset.index !== String(this.stepIndex)) {
        this.stepStatus.dataset.index = String(this.stepIndex);
        this.stepStatus.textContent = `${String(this.stepIndex + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
        this.stepStatus.setAttribute('aria-label', `Paso ${this.stepIndex + 1} de ${this.slides.length}`);
      }
    }

    resizeCarousel() {
      const mobile = this.mobileQuery.matches;
      if (this.stepControls) this.stepControls.hidden = !mobile;
      if (mobile) {
        this.track.setAttribute('tabindex', '0');
        this.track.setAttribute('role', 'region');
        this.track.setAttribute('aria-roledescription', 'carrusel');
        this.goToStep(this.stepIndex, true);
      } else {
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('role');
        this.track.removeAttribute('aria-roledescription');
        this.track.scrollTo({left: 0, behavior: 'instant'});
        this.syncStep();
      }
    }

  stopEnhancements(){this.revealObserver?.disconnect();this.trackObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);this.animations?.forEach(a=>a.cancel());}
  disconnectedCallback(){this.events?.abort();this.stopEnhancements();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produhome"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panda-adults-studio-v3')) {
  customElements.define('panda-adults-studio-v3', class extends HTMLElement {
    connectedCallback() {
      this.stopEnhancements();
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(options), {...options, once: true});
      } else {
        this.initialize(options);
      }
    }

    initialize(options) {
      if (!this.isConnected) return;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      this.panels = [...this.querySelectorAll('[data-offer-panel]')];
      this.media = [...this.querySelectorAll('[data-offer-media]')];
      this.choices = [...this.querySelectorAll('[data-offer-choice]')];
      this.choices.forEach(input => input.addEventListener('change', () => {
        if (input.checked) this.activateOffer(input.value);
      }, options));
      this.panels.forEach(panel => {
        panel.querySelector('[data-variant-select]')?.addEventListener('change', () => this.updateVariant(panel), options);
        panel.querySelector('form')?.addEventListener('submit', event => this.addToCart(event), options);
        this.updateVariant(panel);
      });
      const selected = this.panels.find(panel => panel.dataset.offerPanel === this.dataset.defaultOffer) || this.panels[0];
      if (selected) this.activateOffer(selected.dataset.offerPanel);
      const picker = this.querySelector('[data-offer-picker]');
      if (picker) picker.hidden = this.panels.length < 2;
      this.setupCarousel(options);
      this.setupFeatureTabs(options);
      this.setupPurchaseDetails(options);
      this.setupReviews(options);
      this.setupGallery(options);
      this.setupReveals();
      this.motionQuery.addEventListener('change', () => {
        this.animations.forEach(animation => animation.cancel());
      }, options);
      // Si vuelven atrás desde el checkout, el navegador restaura la página: reactivamos los botones.
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        this.cartPending = false;
        this.choices.forEach(choice => {choice.disabled = false;});
        this.panels.forEach(panel => {
          panel.querySelectorAll('[data-variant-select], [data-quantity]').forEach(field => {field.disabled = false;});
          this.updateVariant(panel);
        });
      }, options);
    }


    setupFeatureTabs(options) {
      this.featureTabs = [...this.querySelectorAll('[data-feature-tab]')];
      this.featurePanels = [...this.querySelectorAll('[data-feature-panel]')];
      const tablist = this.querySelector('[data-feature-tabs]');
      if (!tablist) return;
      tablist.hidden = false;
      this.featurePanels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
        panel.setAttribute('aria-labelledby', this.featureTabs.find(tab => tab.dataset.featureTab === panel.dataset.featurePanel).id);
      });
      this.featureTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateFeature(tab.dataset.featureTab), options);
        tab.addEventListener('keydown', event => {
          const keys = {ArrowRight: (index + 1) % this.featureTabs.length, ArrowLeft: (index - 1 + this.featureTabs.length) % this.featureTabs.length, Home: 0, End: this.featureTabs.length - 1};
          if (!(event.key in keys)) return;
          event.preventDefault();
          const next = this.featureTabs[keys[event.key]];
          next.focus({preventScroll: true});
          next.scrollIntoView({block:'nearest', inline:'nearest', behavior:'instant'});
          this.activateFeature(next.dataset.featureTab);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-feature-panel]');
        if (panel) this.activateFeature(panel.dataset.featurePanel);
      }, options);
      this.activateFeature('safety');
    }

    activateFeature(key) {
      this.featureTabs.forEach(tab => {
        const active = tab.dataset.featureTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.featurePanels.forEach(panel => {
        panel.hidden = panel.dataset.featurePanel !== key;
        if (!panel.hidden) this.reveal(panel);
      });
    }

    setupPurchaseDetails(options) {
      const details = [...this.querySelectorAll('.pa-studio__details details')];
      details.forEach(detail => detail.addEventListener('toggle', () => {
        if (detail.open) details.forEach(other => {if (other !== detail) other.open = false;});
      }, options));
      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.querySelector('[data-sticky-buy]')?.addEventListener('click', () => {
        const panel = this.panels.find(item => item.dataset.offerPanel === this.activeOffer);
        const form = panel?.querySelector('form');
        const button = panel?.querySelector('[data-add-button]');
        if (form && button && !button.disabled) form.requestSubmit(button);
        else this.querySelector('.pa-studio__purchase')?.scrollIntoView({behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'center'});
      }, options);
      if ('IntersectionObserver' in window && this.stickyBar && this.dataset.sticky === 'true') {
        this.purchaseObserver = new IntersectionObserver(entries => {
          const rect = this.getBoundingClientRect();
          const purchase = entries[0];
          this.stickyBar.hidden = !this.panels.length || purchase.isIntersecting || purchase.boundingClientRect.bottom > 0 || rect.bottom < 120;
        });
        this.purchaseObserver.observe(this.querySelector('.pa-studio__purchase'));
        this.stickyObserver = new IntersectionObserver(entries => {if (!entries[0].isIntersecting) this.stickyBar.hidden = true;});
        this.stickyObserver.observe(this);
        window.addEventListener('scroll', () => {
          if (this.stickyFrame) return;
          this.stickyFrame = requestAnimationFrame(() => {
            this.stickyFrame = null;
            const purchase = this.querySelector('.pa-studio__purchase').getBoundingClientRect();
            this.stickyBar.hidden = !this.panels.length || purchase.bottom > 0 || this.getBoundingClientRect().bottom < 120;
          });
        }, {...options, passive:true});
      }
      this.syncSticky();
    }

    syncSticky() {
      const panel = this.panels?.find(item => item.dataset.offerPanel === this.activeOffer);
      const bar = this.querySelector('[data-sticky-bar]');
      if (!panel || !bar) return;
      bar.querySelector('[data-sticky-name]').textContent = panel.querySelector('[data-selected-name]')?.textContent || '';
      bar.querySelector('[data-sticky-price]').textContent = panel.querySelector('[data-product-price]')?.textContent || '';
      const button = bar.querySelector('[data-sticky-buy]');
      const original = panel.querySelector('[data-add-button]');
      button.disabled = this.cartPending || Boolean(original?.disabled);
      button.textContent = original?.textContent || 'Elegir opciones';
    }

    get motionEnabled() {
      return this.dataset.animations !== 'false' && !this.motionQuery?.matches;
    }

    reveal(node, delay = 0) {
      if (!node || !this.motionEnabled || !node.animate) return;
      const animation = node.animate([
        {opacity: 0, transform: 'translateY(16px)'},
        {opacity: 1, transform: 'translateY(0)'}
      ], {duration: 650, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards'});
      this.animations.add(animation);
      animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
    }

    setupReveals() {
      if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
      const targets = [...this.querySelectorAll('.pa-studio__visuals, .pa-studio__purchase > :not(.pa-studio__offer-panel), .pa-studio__section-heading, .pa-studio__steps-grid, .pa-studio__back-link')];
      this.revealObserver = new IntersectionObserver(entries => {
        let order = 0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.revealObserver.unobserve(entry.target);
          this.reveal(entry.target, Math.min(order++ * 55, 220));
        });
      }, {threshold: 0.08});
      targets.forEach(node => this.revealObserver.observe(node));
    }

    setupCarousel(options) {
      this.track = this.querySelector('[data-steps-track]');
      if (!this.track) return;
      this.slides = [...this.track.querySelectorAll('[data-step]')];
      this.stepDots = [...this.querySelectorAll('[data-step-dot]')];
      this.stepPrevious = this.querySelector('[data-step-prev]');
      this.stepNext = this.querySelector('[data-step-next]');
      this.stepStatus = this.querySelector('[data-step-status]');
      this.stepControls = this.querySelector('[data-steps-controls]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.stepIndex = 0;
      this.stepPrevious?.addEventListener('click', () => this.goToStep(this.stepIndex - 1), options);
      this.stepNext?.addEventListener('click', () => this.goToStep(this.stepIndex + 1), options);
      this.stepDots.forEach(dot => dot.addEventListener('click', () => this.goToStep(Number(dot.dataset.stepDot)), options));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.syncStep());
      }, {...options, passive: true});
      this.track.addEventListener('keydown', event => {
        if (!this.mobileQuery.matches || event.target !== this.track) return;
        const indices = {ArrowLeft: this.stepIndex - 1, ArrowRight: this.stepIndex + 1, Home: 0, End: this.slides.length - 1};
        if (!(event.key in indices)) return;
        event.preventDefault();
        this.goToStep(indices[event.key]);
      }, options);
      this.mobileQuery.addEventListener('change', () => this.resizeCarousel(), options);
      if ('ResizeObserver' in window) {
        this.trackObserver = new ResizeObserver(() => this.resizeCarousel());
        this.trackObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.resizeCarousel(), options);
      }
      this.resizeCarousel();
    }

    stepPosition(index) {
      const slide = this.slides[index];
      const left = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      return Math.max(0, Math.min(left, this.track.scrollWidth - this.track.clientWidth));
    }

    goToStep(index, instant = false) {
      if (!this.track || !this.mobileQuery.matches) return;
      const next = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({left: this.stepPosition(next), behavior: instant || !this.motionEnabled ? 'instant' : 'smooth'});
      if (instant) this.syncStep();
    }

    syncStep() {
      if (!this.track || !this.slides.length) return;
      let nearest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const offset = Math.abs(this.track.scrollLeft - this.stepPosition(index));
        if (offset < distance) {nearest = index; distance = offset;}
      });
      this.stepIndex = this.mobileQuery.matches ? nearest : 0;
      this.slides.forEach((slide, index) => slide.classList.toggle('is-current', index === this.stepIndex));
      this.stepDots.forEach((dot, index) => {
        if (index === this.stepIndex) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      });
      if (this.stepPrevious) this.stepPrevious.disabled = this.stepIndex === 0;
      if (this.stepNext) this.stepNext.disabled = this.stepIndex === this.slides.length - 1;
      if (this.stepStatus && this.stepStatus.dataset.index !== String(this.stepIndex)) {
        this.stepStatus.dataset.index = String(this.stepIndex);
        this.stepStatus.textContent = `${String(this.stepIndex + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
        this.stepStatus.setAttribute('aria-label', `Paso ${this.stepIndex + 1} de ${this.slides.length}`);
      }
    }

    resizeCarousel() {
      const mobile = this.mobileQuery.matches;
      if (this.stepControls) this.stepControls.hidden = !mobile;
      if (mobile) {
        this.track.setAttribute('tabindex', '0');
        this.track.setAttribute('role', 'region');
        this.track.setAttribute('aria-roledescription', 'carrusel');
        this.goToStep(this.stepIndex, true);
      } else {
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('role');
        this.track.removeAttribute('aria-roledescription');
        this.track.scrollTo({left: 0, behavior: 'instant'});
        this.syncStep();
      }
    }

    setupGallery(options) {
      this.querySelectorAll('[data-offer-thumbs]').forEach(strip => {
        const key = strip.dataset.offerThumbs;
        const figure = this.querySelector(`.pa-studio__product-media[data-offer-media="${key}"]`);
        const swap = figure?.querySelector('[data-swap]');
        const thumbs = [...strip.querySelectorAll('[data-thumb]')];
        if (!figure || !swap || thumbs.length < 2) return;
        let current = 0;
        const select = index => {
          current = (index + thumbs.length) % thumbs.length;
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === current);
            thumb.setAttribute('aria-pressed', String(i === current));
          });
          const thumb = thumbs[current];
          thumb.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: this.motionEnabled ? 'smooth' : 'instant'});
          if (current === 0) {
            swap.hidden = true;
            figure.classList.remove('is-swapped');
            return;
          }
          swap.srcset = thumb.dataset.srcset || '';
          swap.sizes = '(max-width: 749px) 90vw, 50vw';
          swap.src = thumb.dataset.full;
          swap.alt = thumb.dataset.alt || '';
          swap.hidden = false;
          figure.classList.add('is-swapped');
          swap.classList.remove('is-in');
          void swap.offsetWidth;
          swap.classList.add('is-in');
        };
        figure.paSelect = select;
        thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i), options));
        figure.querySelector('[data-gallery-prev]')?.addEventListener('click', () => select(current - 1), options);
        figure.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(current + 1), options);
        let startX = null;
        figure.addEventListener('touchstart', event => {startX = event.touches[0].clientX;}, {...options, passive: true});
        figure.addEventListener('touchend', event => {
          if (startX === null) return;
          const dx = event.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) select(current + (dx < 0 ? 1 : -1));
        }, {...options, passive: true});
      });
    }

    setupReviews(options) {
      const dialog = this.querySelector('[data-reviews-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      this.reviewsDialog = dialog;
      this.querySelectorAll('[data-reviews-open]').forEach(button => button.addEventListener('click', () => this.openReviews(button), options));
      dialog.querySelector('[data-reviews-close]')?.addEventListener('click', () => this.closeReviews(), options);
      dialog.addEventListener('click', event => {if (event.target === dialog) this.closeReviews();}, options);
      dialog.addEventListener('cancel', event => {event.preventDefault(); this.closeReviews();}, options);
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('pa-scroll-lock');
        this.reviewsOpener?.focus({preventScroll: true});
      }, options);
      dialog.querySelector('[data-reviews-buy]')?.addEventListener('click', () => {
        this.closeReviews();
        this.querySelector('.pa-studio__purchase')?.scrollIntoView({behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'start'});
      }, options);
      this.addEventListener('shopify:block:select', event => {if (event.target.closest('[data-reviews-dialog]')) this.openReviews();}, options);
    }

    openReviews(opener) {
      const dialog = this.reviewsDialog;
      if (!dialog || dialog.open) return;
      this.reviewsOpener = opener || null;
      dialog.classList.remove('is-closing');
      dialog.showModal();
      document.documentElement.classList.add('pa-scroll-lock');
      const list = dialog.querySelector('.pa-reviews__list');
      if (list) list.scrollTop = 0;
    }

    closeReviews() {
      const dialog = this.reviewsDialog;
      if (!dialog?.open || dialog.classList.contains('is-closing')) return;
      if (!this.motionEnabled) {dialog.close(); return;}
      const sheet = dialog.querySelector('.pa-reviews__sheet');
      dialog.classList.add('is-closing');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        dialog.classList.remove('is-closing');
        dialog.close();
      };
      sheet?.addEventListener('animationend', event => {if (event.target === sheet) finish();});
      setTimeout(finish, 360);
    }

    stopEnhancements() {
      this.revealObserver?.disconnect();
      this.trackObserver?.disconnect();
      this.purchaseObserver?.disconnect();
      this.stickyObserver?.disconnect();
      cancelAnimationFrame(this.stickyFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.animations?.forEach(animation => animation.cancel());
      if (this.reviewsDialog?.open) this.reviewsDialog.close();
      document.documentElement.classList.remove('pa-scroll-lock');
    }

    activateOffer(key) {
      if (this.cartPending || !this.panels.some(panel => panel.dataset.offerPanel === key)) return;
      const changed = this.activeOffer && this.activeOffer !== key;
      this.activeOffer = key;
      this.panels.forEach(panel => {panel.hidden = panel.dataset.offerPanel !== key;});
      this.media.forEach(media => {media.hidden = media.dataset.offerMedia !== key;});
      this.choices.forEach(choice => {choice.checked = choice.value === key;});
      const hasDuoShip = Boolean(this.querySelector('[data-ship-offer="duo"]'));
      this.querySelectorAll('[data-ship-offer]').forEach(node => {
        node.hidden = hasDuoShip ? node.dataset.shipOffer !== key : false;
      });
      this.querySelector('[data-sticky-cart]')?.setAttribute('hidden', '');
      const productUrl = this.panels.find(panel => panel.dataset.offerPanel === key)?.dataset.productUrl;
      if (productUrl) this.querySelectorAll('[data-product-link]').forEach(link => {link.href = productUrl;});
      this.syncSticky();
      if (changed) {
        this.reveal(this.media.find(media => media.dataset.offerMedia === key));
        this.reveal(this.panels.find(panel => panel.dataset.offerPanel === key), 45);
      }
    }

    updateVariant(panel) {
      const option = panel.querySelector('[data-variant-select]')?.selectedOptions[0];
      if (!option) return;
      const price = panel.querySelector('[data-product-price]');
      const compare = panel.querySelector('[data-product-compare]');
      const installment = panel.querySelector('[data-installment]');
      const button = panel.querySelector('[data-add-button]');
      const quantity = panel.querySelector('[data-quantity]');
      if (price) price.textContent = option.dataset.price;
      if (compare) {compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;}
      if (installment && option.dataset.installment) installment.textContent = option.dataset.installment;
      if (button) {button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Agotado' : button.dataset.label;}
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        quantity.value = quantity.min;
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
      }
      const cardPrice = this.querySelector('[data-offer-card-price="' + panel.dataset.offerPanel + '"]');
      if (cardPrice) cardPrice.textContent = option.dataset.price;
      const media = this.media.find(node => node.dataset.offerMedia === panel.dataset.offerPanel);
      media?.paSelect?.(0);
      if (media && media.dataset.customImage !== 'true' && option.dataset.image) {
        media.querySelectorAll('.pa-studio__product-image').forEach(image => {
          if (image.getAttribute('src') !== option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
          image.alt = option.dataset.alt || '';
        });
      }
      const feedback = panel.querySelector('[data-cart-feedback]');
      if (feedback) feedback.hidden = true;
      this.syncSticky();
    }

    async addToCart(event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (this.cartPending || !form?.reportValidity()) return;
      const panel = form.closest('[data-offer-panel]');
      const button = form.querySelector('[data-add-button]');
      if (!panel || !button || button.disabled) return;
      const select = form.querySelector('[data-variant-select]');
      const quantity = form.querySelector('[data-quantity]');
      const feedback = panel.querySelector('[data-cart-feedback]');
      const message = panel.querySelector('[data-cart-message]');
      const body = new FormData(form);
      const sectionIds = [...new Set([...document.querySelectorAll('cart-icon, cart-drawer-component, cart-notification, #cart-icon-bubble')]
        .map(node => node.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '')).filter(Boolean))].slice(0, 5);
      if (sectionIds.length) {body.set('sections', sectionIds.join(',')); body.set('sections_url', window.location.pathname);}
      this.cartPending = true;
      button.disabled = true;
      button.textContent = 'Agregando…';
      this.syncSticky();
      if (select) select.disabled = true;
      if (quantity) quantity.disabled = true;
      this.choices.forEach(choice => {choice.disabled = true;});
      if (feedback) {feedback.hidden = true; feedback.classList.remove('has-error');}
      const request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 20000);
      let confirmed = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST', body, headers: {Accept: 'application/json'}, credentials: 'same-origin', signal: request.signal
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const error = new Error(result.description || result.message || 'No se pudo agregar esta opción. Revisá el stock y la cantidad.');
          error.cartResponse = true;
          throw error;
        }
        confirmed = true;
        if (this.dataset.directCheckout !== 'false') {
          button.textContent = 'Yendo al pago…';
          window.location.href = '/checkout';
          return;
        }
        this.querySelector('[data-sticky-cart]')?.removeAttribute('hidden');
        if (feedback) feedback.hidden = false;
        if (message) message.textContent = panel.dataset.offerPanel === 'duo' ? 'Tu pack Dúo se agregó al carrito.' : 'Tu Panda Adults se agregó al carrito.';
        try {this.refreshCartSections(result.sections);} catch (_) {}
      } catch (error) {
        if (!confirmed) {
          if (feedback) {feedback.hidden = false; feedback.classList.add('has-error');}
          if (message) message.textContent = error.cartResponse ? error.message : 'No pudimos confirmar la respuesta. Revisá tu carrito antes de volver a intentar.';
        }
      } finally {
        clearTimeout(timeout);
        if (confirmed && this.dataset.directCheckout !== 'false') return;
        this.cartPending = false;
        if (select) select.disabled = false;
        if (quantity) quantity.disabled = false;
        this.choices.forEach(choice => {choice.disabled = false;});
        const available = select?.selectedOptions[0]?.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.label : 'Agotado';
        this.syncSticky();
      }
    }

    refreshCartSections(sections) {
      if (!sections) return;
      for (const html of Object.values(sections)) {
        if (typeof html !== 'string') continue;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        for (const selector of ['cart-icon', 'cart-drawer-component', 'cart-notification', '#cart-icon-bubble']) {
          const current = document.querySelector(selector);
          const replacement = parsed.querySelector(selector);
          if (current && replacement) current.replaceWith(replacement);
        }
      }
    }

    disconnectedCallback() {this.events?.abort(); this.stopEnhancements();}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["situaciones"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('panda-use-stories-v2')){
 customElements.define('panda-use-stories-v2',class extends HTMLElement{
  connectedCallback(){
   this.events?.abort();this.events=new AbortController();const options={signal:this.events.signal};
   const init=()=>{if(!this.isConnected)return;this.track=this.querySelector('[data-track]');this.cards=[...this.querySelectorAll('[data-card]')];this.controls=this.querySelector('[data-controls]');this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.count=this.querySelector('[data-count]');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.progress=this.querySelector('[data-progress]');this.animations=new Set();this.setupMotion(options);
    this.prev.addEventListener('click',()=>this.move(-1),options);this.next.addEventListener('click',()=>this.move(1),options);
    this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.sync());},{...options,passive:true});
    this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}if(e.key==='Home'||e.key==='End'){e.preventDefault();this.go(e.key==='Home'?0:this.cards.length-1);}},options);
    this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('[data-card]');const i=this.cards.indexOf(card);if(i>=0)this.go(i);},options);
    this.resize=new ResizeObserver(()=>this.sync());this.resize.observe(this.track);this.sync();
   };if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init,{...options,once:true});}else{init();}
  }
  positions(){const base=this.track.getBoundingClientRect().left;const max=this.track.scrollWidth-this.track.clientWidth;return this.cards.map(c=>Math.max(0,Math.min(max,c.getBoundingClientRect().left-base+this.track.scrollLeft)));}
  sync(){const max=this.track.scrollWidth-this.track.clientWidth;this.controls.hidden=max<3;const x=this.track.scrollLeft;this.prev.disabled=x<=2;this.next.disabled=x>=max-2;const positions=this.positions();let index=0;positions.forEach((p,i)=>{if(Math.abs(p-x)<Math.abs(positions[index]-x))index=i;});if(x>=max-2&&max>2)index=this.cards.length-1;const label=String(index+1).padStart(2,'0')+' / '+String(this.cards.length).padStart(2,'0');if(this.count.textContent!==label)this.count.textContent=label;if(this.progress){const fraction=max>2?Math.min(1,Math.max(.12,(x+this.track.clientWidth)/this.track.scrollWidth)):1;this.progress.style.transform='scaleX('+fraction+')';}}
  move(direction){const x=this.track.scrollLeft;const positions=this.positions();const target=direction>0?positions.find(p=>p>x+3):positions.slice().reverse().find(p=>p<x-3);if(target!==undefined)this.scroll(target);}
  go(i){const p=this.positions()[i];if(p!==undefined)this.scroll(p);}
  scroll(left){this.track.scrollTo({left,behavior:this.reduced.matches||this.dataset.motion==='false'?'instant':'smooth'});}

  get motionEnabled(){return this.dataset.motion!=='false'&&!this.reduced.matches;}
  animateNode(node,frames,options){if(!this.motionEnabled||!node?.animate)return;const a=node.animate(frames,options);this.animations.add(a);a.finished.catch(()=>{}).finally(()=>this.animations.delete(a));}
  setupMotion(options){
   this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.animations.forEach(a=>a.cancel());},options);
   if('IntersectionObserver' in window){
    this.reveals=new IntersectionObserver(entries=>{let delay=0;entries.forEach(e=>{if(!e.isIntersecting)return;this.reveals.unobserve(e.target);this.animateNode(e.target,[{opacity:0,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}],{duration:680,delay:delay,easing:'cubic-bezier(.2,.75,.25,1)',fill:'backwards'});delay+=75;});},{threshold:.12});
    [this.querySelector('.pa-stories__heading'),...this.cards].filter(Boolean).forEach(n=>this.reveals.observe(n));
   }
   this.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open){this.animateNode(d.querySelector('div'),[{opacity:0,transform:'translateY(-6px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'ease-out'});}},{signal:options.signal}));
  }
  disconnectedCallback(){this.reveals?.disconnect();this.animations?.forEach(a=>a.cancel());this.events?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panda-adults-studio-v3')) {
  customElements.define('panda-adults-studio-v3', class extends HTMLElement {
    connectedCallback() {
      this.stopEnhancements();
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(options), {...options, once: true});
      } else {
        this.initialize(options);
      }
    }

    initialize(options) {
      if (!this.isConnected) return;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      this.panels = [...this.querySelectorAll('[data-offer-panel]')];
      this.media = [...this.querySelectorAll('[data-offer-media]')];
      this.choices = [...this.querySelectorAll('[data-offer-choice]')];
      this.choices.forEach(input => input.addEventListener('change', () => {
        if (input.checked) this.activateOffer(input.value);
      }, options));
      this.panels.forEach(panel => {
        panel.querySelector('[data-variant-select]')?.addEventListener('change', () => this.updateVariant(panel), options);
        panel.querySelector('form')?.addEventListener('submit', event => this.addToCart(event), options);
        this.updateVariant(panel);
      });
      const selected = this.panels.find(panel => panel.dataset.offerPanel === this.dataset.defaultOffer) || this.panels[0];
      if (selected) this.activateOffer(selected.dataset.offerPanel);
      const picker = this.querySelector('[data-offer-picker]');
      if (picker) picker.hidden = this.panels.length < 2;
      this.setupCarousel(options);
      this.setupFeatureTabs(options);
      this.setupPurchaseDetails(options);
      this.setupReviews(options);
      this.setupGallery(options);
      this.setupReveals();
      this.motionQuery.addEventListener('change', () => {
        this.animations.forEach(animation => animation.cancel());
      }, options);
      // Si vuelven atrás desde el checkout, el navegador restaura la página: reactivamos los botones.
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        this.cartPending = false;
        this.choices.forEach(choice => {choice.disabled = false;});
        this.panels.forEach(panel => {
          panel.querySelectorAll('[data-variant-select], [data-quantity]').forEach(field => {field.disabled = false;});
          this.updateVariant(panel);
        });
      }, options);
    }


    setupFeatureTabs(options) {
      this.featureTabs = [...this.querySelectorAll('[data-feature-tab]')];
      this.featurePanels = [...this.querySelectorAll('[data-feature-panel]')];
      const tablist = this.querySelector('[data-feature-tabs]');
      if (!tablist) return;
      tablist.hidden = false;
      this.featurePanels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
        panel.setAttribute('aria-labelledby', this.featureTabs.find(tab => tab.dataset.featureTab === panel.dataset.featurePanel).id);
      });
      this.featureTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateFeature(tab.dataset.featureTab), options);
        tab.addEventListener('keydown', event => {
          const keys = {ArrowRight: (index + 1) % this.featureTabs.length, ArrowLeft: (index - 1 + this.featureTabs.length) % this.featureTabs.length, Home: 0, End: this.featureTabs.length - 1};
          if (!(event.key in keys)) return;
          event.preventDefault();
          const next = this.featureTabs[keys[event.key]];
          next.focus({preventScroll: true});
          next.scrollIntoView({block:'nearest', inline:'nearest', behavior:'instant'});
          this.activateFeature(next.dataset.featureTab);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-feature-panel]');
        if (panel) this.activateFeature(panel.dataset.featurePanel);
      }, options);
      this.activateFeature('safety');
    }

    activateFeature(key) {
      this.featureTabs.forEach(tab => {
        const active = tab.dataset.featureTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.featurePanels.forEach(panel => {
        panel.hidden = panel.dataset.featurePanel !== key;
        if (!panel.hidden) this.reveal(panel);
      });
    }

    setupPurchaseDetails(options) {
      const details = [...this.querySelectorAll('.pa-studio__details details')];
      details.forEach(detail => detail.addEventListener('toggle', () => {
        if (detail.open) details.forEach(other => {if (other !== detail) other.open = false;});
      }, options));
      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.querySelector('[data-sticky-buy]')?.addEventListener('click', () => {
        const panel = this.panels.find(item => item.dataset.offerPanel === this.activeOffer);
        const form = panel?.querySelector('form');
        const button = panel?.querySelector('[data-add-button]');
        if (form && button && !button.disabled) form.requestSubmit(button);
        else this.querySelector('.pa-studio__purchase')?.scrollIntoView({behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'center'});
      }, options);
      if ('IntersectionObserver' in window && this.stickyBar && this.dataset.sticky === 'true') {
        this.purchaseObserver = new IntersectionObserver(entries => {
          const rect = this.getBoundingClientRect();
          const purchase = entries[0];
          this.stickyBar.hidden = !this.panels.length || purchase.isIntersecting || purchase.boundingClientRect.bottom > 0 || rect.bottom < 120;
        });
        this.purchaseObserver.observe(this.querySelector('.pa-studio__purchase'));
        this.stickyObserver = new IntersectionObserver(entries => {if (!entries[0].isIntersecting) this.stickyBar.hidden = true;});
        this.stickyObserver.observe(this);
        window.addEventListener('scroll', () => {
          if (this.stickyFrame) return;
          this.stickyFrame = requestAnimationFrame(() => {
            this.stickyFrame = null;
            const purchase = this.querySelector('.pa-studio__purchase').getBoundingClientRect();
            this.stickyBar.hidden = !this.panels.length || purchase.bottom > 0 || this.getBoundingClientRect().bottom < 120;
          });
        }, {...options, passive:true});
      }
      this.syncSticky();
    }

    syncSticky() {
      const panel = this.panels?.find(item => item.dataset.offerPanel === this.activeOffer);
      const bar = this.querySelector('[data-sticky-bar]');
      if (!panel || !bar) return;
      bar.querySelector('[data-sticky-name]').textContent = panel.querySelector('[data-selected-name]')?.textContent || '';
      bar.querySelector('[data-sticky-price]').textContent = panel.querySelector('[data-product-price]')?.textContent || '';
      const button = bar.querySelector('[data-sticky-buy]');
      const original = panel.querySelector('[data-add-button]');
      button.disabled = this.cartPending || Boolean(original?.disabled);
      button.textContent = original?.textContent || 'Elegir opciones';
    }

    get motionEnabled() {
      return this.dataset.animations !== 'false' && !this.motionQuery?.matches;
    }

    reveal(node, delay = 0) {
      if (!node || !this.motionEnabled || !node.animate) return;
      const animation = node.animate([
        {opacity: 0, transform: 'translateY(16px)'},
        {opacity: 1, transform: 'translateY(0)'}
      ], {duration: 650, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards'});
      this.animations.add(animation);
      animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
    }

    setupReveals() {
      if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
      const targets = [...this.querySelectorAll('.pa-studio__visuals, .pa-studio__purchase > :not(.pa-studio__offer-panel), .pa-studio__section-heading, .pa-studio__steps-grid, .pa-studio__back-link')];
      this.revealObserver = new IntersectionObserver(entries => {
        let order = 0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.revealObserver.unobserve(entry.target);
          this.reveal(entry.target, Math.min(order++ * 55, 220));
        });
      }, {threshold: 0.08});
      targets.forEach(node => this.revealObserver.observe(node));
    }

    setupCarousel(options) {
      this.track = this.querySelector('[data-steps-track]');
      if (!this.track) return;
      this.slides = [...this.track.querySelectorAll('[data-step]')];
      this.stepDots = [...this.querySelectorAll('[data-step-dot]')];
      this.stepPrevious = this.querySelector('[data-step-prev]');
      this.stepNext = this.querySelector('[data-step-next]');
      this.stepStatus = this.querySelector('[data-step-status]');
      this.stepControls = this.querySelector('[data-steps-controls]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.stepIndex = 0;
      this.stepPrevious?.addEventListener('click', () => this.goToStep(this.stepIndex - 1), options);
      this.stepNext?.addEventListener('click', () => this.goToStep(this.stepIndex + 1), options);
      this.stepDots.forEach(dot => dot.addEventListener('click', () => this.goToStep(Number(dot.dataset.stepDot)), options));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.syncStep());
      }, {...options, passive: true});
      this.track.addEventListener('keydown', event => {
        if (!this.mobileQuery.matches || event.target !== this.track) return;
        const indices = {ArrowLeft: this.stepIndex - 1, ArrowRight: this.stepIndex + 1, Home: 0, End: this.slides.length - 1};
        if (!(event.key in indices)) return;
        event.preventDefault();
        this.goToStep(indices[event.key]);
      }, options);
      this.mobileQuery.addEventListener('change', () => this.resizeCarousel(), options);
      if ('ResizeObserver' in window) {
        this.trackObserver = new ResizeObserver(() => this.resizeCarousel());
        this.trackObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.resizeCarousel(), options);
      }
      this.resizeCarousel();
    }

    stepPosition(index) {
      const slide = this.slides[index];
      const left = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      return Math.max(0, Math.min(left, this.track.scrollWidth - this.track.clientWidth));
    }

    goToStep(index, instant = false) {
      if (!this.track || !this.mobileQuery.matches) return;
      const next = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({left: this.stepPosition(next), behavior: instant || !this.motionEnabled ? 'instant' : 'smooth'});
      if (instant) this.syncStep();
    }

    syncStep() {
      if (!this.track || !this.slides.length) return;
      let nearest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const offset = Math.abs(this.track.scrollLeft - this.stepPosition(index));
        if (offset < distance) {nearest = index; distance = offset;}
      });
      this.stepIndex = this.mobileQuery.matches ? nearest : 0;
      this.slides.forEach((slide, index) => slide.classList.toggle('is-current', index === this.stepIndex));
      this.stepDots.forEach((dot, index) => {
        if (index === this.stepIndex) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      });
      if (this.stepPrevious) this.stepPrevious.disabled = this.stepIndex === 0;
      if (this.stepNext) this.stepNext.disabled = this.stepIndex === this.slides.length - 1;
      if (this.stepStatus && this.stepStatus.dataset.index !== String(this.stepIndex)) {
        this.stepStatus.dataset.index = String(this.stepIndex);
        this.stepStatus.textContent = `${String(this.stepIndex + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
        this.stepStatus.setAttribute('aria-label', `Paso ${this.stepIndex + 1} de ${this.slides.length}`);
      }
    }

    resizeCarousel() {
      const mobile = this.mobileQuery.matches;
      if (this.stepControls) this.stepControls.hidden = !mobile;
      if (mobile) {
        this.track.setAttribute('tabindex', '0');
        this.track.setAttribute('role', 'region');
        this.track.setAttribute('aria-roledescription', 'carrusel');
        this.goToStep(this.stepIndex, true);
      } else {
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('role');
        this.track.removeAttribute('aria-roledescription');
        this.track.scrollTo({left: 0, behavior: 'instant'});
        this.syncStep();
      }
    }

    setupGallery(options) {
      this.querySelectorAll('[data-offer-thumbs]').forEach(strip => {
        const key = strip.dataset.offerThumbs;
        const figure = this.querySelector(`.pa-studio__product-media[data-offer-media="${key}"]`);
        const swap = figure?.querySelector('[data-swap]');
        const thumbs = [...strip.querySelectorAll('[data-thumb]')];
        if (!figure || !swap || thumbs.length < 2) return;
        let current = 0;
        const select = index => {
          current = (index + thumbs.length) % thumbs.length;
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === current);
            thumb.setAttribute('aria-pressed', String(i === current));
          });
          const thumb = thumbs[current];
          thumb.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: this.motionEnabled ? 'smooth' : 'instant'});
          if (current === 0) {
            swap.hidden = true;
            figure.classList.remove('is-swapped');
            return;
          }
          swap.srcset = thumb.dataset.srcset || '';
          swap.sizes = '(max-width: 749px) 90vw, 50vw';
          swap.src = thumb.dataset.full;
          swap.alt = thumb.dataset.alt || '';
          swap.hidden = false;
          figure.classList.add('is-swapped');
          swap.classList.remove('is-in');
          void swap.offsetWidth;
          swap.classList.add('is-in');
        };
        figure.paSelect = select;
        thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i), options));
        figure.querySelector('[data-gallery-prev]')?.addEventListener('click', () => select(current - 1), options);
        figure.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(current + 1), options);
        let startX = null;
        figure.addEventListener('touchstart', event => {startX = event.touches[0].clientX;}, {...options, passive: true});
        figure.addEventListener('touchend', event => {
          if (startX === null) return;
          const dx = event.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) select(current + (dx < 0 ? 1 : -1));
        }, {...options, passive: true});
      });
    }

    setupReviews(options) {
      const dialog = this.querySelector('[data-reviews-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      this.reviewsDialog = dialog;
      this.querySelectorAll('[data-reviews-open]').forEach(button => button.addEventListener('click', () => this.openReviews(button), options));
      dialog.querySelector('[data-reviews-close]')?.addEventListener('click', () => this.closeReviews(), options);
      dialog.addEventListener('click', event => {if (event.target === dialog) this.closeReviews();}, options);
      dialog.addEventListener('cancel', event => {event.preventDefault(); this.closeReviews();}, options);
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('pa-scroll-lock');
        this.reviewsOpener?.focus({preventScroll: true});
      }, options);
      dialog.querySelector('[data-reviews-buy]')?.addEventListener('click', () => {
        this.closeReviews();
        this.querySelector('.pa-studio__purchase')?.scrollIntoView({behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'start'});
      }, options);
      this.addEventListener('shopify:block:select', event => {if (event.target.closest('[data-reviews-dialog]')) this.openReviews();}, options);
    }

    openReviews(opener) {
      const dialog = this.reviewsDialog;
      if (!dialog || dialog.open) return;
      this.reviewsOpener = opener || null;
      dialog.classList.remove('is-closing');
      dialog.showModal();
      document.documentElement.classList.add('pa-scroll-lock');
      const list = dialog.querySelector('.pa-reviews__list');
      if (list) list.scrollTop = 0;
    }

    closeReviews() {
      const dialog = this.reviewsDialog;
      if (!dialog?.open || dialog.classList.contains('is-closing')) return;
      if (!this.motionEnabled) {dialog.close(); return;}
      const sheet = dialog.querySelector('.pa-reviews__sheet');
      dialog.classList.add('is-closing');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        dialog.classList.remove('is-closing');
        dialog.close();
      };
      sheet?.addEventListener('animationend', event => {if (event.target === sheet) finish();});
      setTimeout(finish, 360);
    }

    stopEnhancements() {
      this.revealObserver?.disconnect();
      this.trackObserver?.disconnect();
      this.purchaseObserver?.disconnect();
      this.stickyObserver?.disconnect();
      cancelAnimationFrame(this.stickyFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.animations?.forEach(animation => animation.cancel());
      if (this.reviewsDialog?.open) this.reviewsDialog.close();
      document.documentElement.classList.remove('pa-scroll-lock');
    }

    activateOffer(key) {
      if (this.cartPending || !this.panels.some(panel => panel.dataset.offerPanel === key)) return;
      const changed = this.activeOffer && this.activeOffer !== key;
      this.activeOffer = key;
      this.panels.forEach(panel => {panel.hidden = panel.dataset.offerPanel !== key;});
      this.media.forEach(media => {media.hidden = media.dataset.offerMedia !== key;});
      this.choices.forEach(choice => {choice.checked = choice.value === key;});
      const hasDuoShip = Boolean(this.querySelector('[data-ship-offer="duo"]'));
      this.querySelectorAll('[data-ship-offer]').forEach(node => {
        node.hidden = hasDuoShip ? node.dataset.shipOffer !== key : false;
      });
      this.querySelector('[data-sticky-cart]')?.setAttribute('hidden', '');
      const productUrl = this.panels.find(panel => panel.dataset.offerPanel === key)?.dataset.productUrl;
      if (productUrl) this.querySelectorAll('[data-product-link]').forEach(link => {link.href = productUrl;});
      this.syncSticky();
      if (changed) {
        this.reveal(this.media.find(media => media.dataset.offerMedia === key));
        this.reveal(this.panels.find(panel => panel.dataset.offerPanel === key), 45);
      }
    }

    updateVariant(panel) {
      const option = panel.querySelector('[data-variant-select]')?.selectedOptions[0];
      if (!option) return;
      const price = panel.querySelector('[data-product-price]');
      const compare = panel.querySelector('[data-product-compare]');
      const installment = panel.querySelector('[data-installment]');
      const button = panel.querySelector('[data-add-button]');
      const quantity = panel.querySelector('[data-quantity]');
      if (price) price.textContent = option.dataset.price;
      if (compare) {compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;}
      if (installment && option.dataset.installment) installment.textContent = option.dataset.installment;
      if (button) {button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Agotado' : button.dataset.label;}
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        quantity.value = quantity.min;
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
      }
      const cardPrice = this.querySelector('[data-offer-card-price="' + panel.dataset.offerPanel + '"]');
      if (cardPrice) cardPrice.textContent = option.dataset.price;
      const media = this.media.find(node => node.dataset.offerMedia === panel.dataset.offerPanel);
      media?.paSelect?.(0);
      if (media && media.dataset.customImage !== 'true' && option.dataset.image) {
        media.querySelectorAll('.pa-studio__product-image').forEach(image => {
          if (image.getAttribute('src') !== option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
          image.alt = option.dataset.alt || '';
        });
      }
      const feedback = panel.querySelector('[data-cart-feedback]');
      if (feedback) feedback.hidden = true;
      this.syncSticky();
    }

    async addToCart(event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (this.cartPending || !form?.reportValidity()) return;
      const panel = form.closest('[data-offer-panel]');
      const button = form.querySelector('[data-add-button]');
      if (!panel || !button || button.disabled) return;
      const select = form.querySelector('[data-variant-select]');
      const quantity = form.querySelector('[data-quantity]');
      const feedback = panel.querySelector('[data-cart-feedback]');
      const message = panel.querySelector('[data-cart-message]');
      const body = new FormData(form);
      const sectionIds = [...new Set([...document.querySelectorAll('cart-icon, cart-drawer-component, cart-notification, #cart-icon-bubble')]
        .map(node => node.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '')).filter(Boolean))].slice(0, 5);
      if (sectionIds.length) {body.set('sections', sectionIds.join(',')); body.set('sections_url', window.location.pathname);}
      this.cartPending = true;
      button.disabled = true;
      button.textContent = 'Agregando…';
      this.syncSticky();
      if (select) select.disabled = true;
      if (quantity) quantity.disabled = true;
      this.choices.forEach(choice => {choice.disabled = true;});
      if (feedback) {feedback.hidden = true; feedback.classList.remove('has-error');}
      const request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 20000);
      let confirmed = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST', body, headers: {Accept: 'application/json'}, credentials: 'same-origin', signal: request.signal
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const error = new Error(result.description || result.message || 'No se pudo agregar esta opción. Revisá el stock y la cantidad.');
          error.cartResponse = true;
          throw error;
        }
        confirmed = true;
        if (this.dataset.directCheckout !== 'false') {
          button.textContent = 'Yendo al pago…';
          window.location.href = '/checkout';
          return;
        }
        this.querySelector('[data-sticky-cart]')?.removeAttribute('hidden');
        if (feedback) feedback.hidden = false;
        if (message) message.textContent = panel.dataset.offerPanel === 'duo' ? 'Tu pack Dúo se agregó al carrito.' : 'Tu Panda Adults se agregó al carrito.';
        try {this.refreshCartSections(result.sections);} catch (_) {}
      } catch (error) {
        if (!confirmed) {
          if (feedback) {feedback.hidden = false; feedback.classList.add('has-error');}
          if (message) message.textContent = error.cartResponse ? error.message : 'No pudimos confirmar la respuesta. Revisá tu carrito antes de volver a intentar.';
        }
      } finally {
        clearTimeout(timeout);
        if (confirmed && this.dataset.directCheckout !== 'false') return;
        this.cartPending = false;
        if (select) select.disabled = false;
        if (quantity) quantity.disabled = false;
        this.choices.forEach(choice => {choice.disabled = false;});
        const available = select?.selectedOptions[0]?.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.label : 'Agotado';
        this.syncSticky();
      }
    }

    refreshCartSections(sections) {
      if (!sections) return;
      for (const html of Object.values(sections)) {
        if (typeof html !== 'string') continue;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        for (const selector of ['cart-icon', 'cart-drawer-component', 'cart-notification', '#cart-icon-bubble']) {
          const current = document.querySelector(selector);
          const replacement = parsed.querySelector(selector);
          if (current && replacement) current.replaceWith(replacement);
        }
      }
    }

    disconnectedCallback() {this.events?.abort(); this.stopEnhancements();}
  });
}


  } catch(e) { console.error(e); }
})();
})();
